function PlanDD({ ...props }) {
	return (
		<g {...props} id="unit-dd">
			<g id="furniture">
				<polyline
					points="848.48 495.64 848.48 498.12 843.58 498.12 843.58 495.64 848.48 495.64"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="911.87 500.61 911.87 788 856.93 788 856.93 500.61 911.87 500.61"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="564.15 652.19 564.15 493.37 598.49 527.71 598.49 652.19 564.15 652.19"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="703.73 860.78 703.73 917.35 647.17 917.35 647.17 860.78 703.73 860.78"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="381.85 53.68 381.85 58.64 419.58 58.64 419.58 53.68 381.85 53.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="421.38 53.23 380.04 53.23 380.04 53.68 421.38 53.68 421.38 53.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="421.38"
					y1="53.68"
					x2="421.38"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.04"
					y1="53.68"
					x2="421.38"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.04"
					y1="53.23"
					x2="380.04"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.38"
					y1="53.23"
					x2="380.04"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.85"
					y1="58.64"
					x2="419.58"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.58"
					y1="53.68"
					x2="381.85"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="377.79 58.64 381.85 58.64 381.85 53.68 377.79 53.68 377.79 58.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="377.79"
					y1="53.68"
					x2="377.79"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.85"
					y1="53.68"
					x2="377.79"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.85"
					y1="58.64"
					x2="381.85"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.79"
					y1="58.64"
					x2="381.85"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="423.64 53.68 419.58 53.68 419.58 58.64 423.64 58.64 423.64 53.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="423.64"
					y1="58.64"
					x2="423.64"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.58"
					y1="58.64"
					x2="423.64"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="419.58"
					y1="53.68"
					x2="419.58"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.64"
					y1="53.68"
					x2="419.58"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="381.85"
					y1="54.58"
					x2="419.58"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="375.99 58.19 377.79 58.19 377.79 53.68 380.04 53.68 380.04 53.23 375.99 53.23 375.99 58.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="375.99"
					y1="53.23"
					x2="375.99"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.04"
					y1="53.23"
					x2="375.99"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="380.04"
					y1="53.68"
					x2="380.04"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.79"
					y1="53.68"
					x2="380.04"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="377.79"
					y1="58.19"
					x2="377.79"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.99"
					y1="58.19"
					x2="377.79"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="425.44 53.23 421.38 53.23 421.38 53.68 423.64 53.68 423.64 58.19 425.44 58.19 425.44 53.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="425.44"
					y1="58.19"
					x2="425.44"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.64"
					y1="58.19"
					x2="425.44"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="423.64"
					y1="53.68"
					x2="423.64"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.38"
					y1="53.68"
					x2="423.64"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="421.38"
					y1="53.23"
					x2="421.38"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.44"
					y1="53.23"
					x2="421.38"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="427.73 54.58 427.73 56.87 549.06 56.87 549.06 54.58 427.73 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="549.06"
					y1="54.58"
					x2="427.73"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.06"
					y1="56.87"
					x2="549.06"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.73"
					y1="56.87"
					x2="549.06"
					y2="56.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="427.73"
					y1="54.58"
					x2="427.73"
					y2="56.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="375.99 54.58 375.99 68.32 371.41 68.32 371.41 54.58 375.99 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="375.99"
					y1="68.32"
					x2="375.99"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.41"
					y1="68.32"
					x2="375.99"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.41"
					y1="54.58"
					x2="371.41"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="375.99"
					y1="54.58"
					x2="371.41"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="430.02 54.58 430.02 68.32 425.44 68.32 425.44 54.58 430.02 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="430.02"
					y1="68.32"
					x2="430.02"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.44"
					y1="68.32"
					x2="430.02"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="425.44"
					y1="54.58"
					x2="425.44"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="430.02"
					y1="54.58"
					x2="425.44"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="551.35 54.58 551.35 68.32 546.77 68.32 546.77 54.58 551.35 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="551.35"
					y1="68.32"
					x2="551.35"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.77"
					y1="68.32"
					x2="551.35"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.77"
					y1="54.58"
					x2="546.77"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.35"
					y1="54.58"
					x2="546.77"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="698.11 53.68 698.11 58.64 735.84 58.64 735.84 53.68 698.11 53.68"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="737.65 53.23 696.31 53.23 696.31 53.68 737.65 53.68 737.65 53.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="737.65"
					y1="53.68"
					x2="737.65"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.31"
					y1="53.68"
					x2="737.65"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.31"
					y1="53.23"
					x2="696.31"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.65"
					y1="53.23"
					x2="696.31"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="58.64"
					x2="735.84"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.84"
					y1="53.68"
					x2="698.11"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="694.06 58.64 698.11 58.64 698.11 53.68 694.06 53.68 694.06 58.64"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="694.06"
					y1="53.68"
					x2="694.06"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="53.68"
					x2="694.06"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="58.64"
					x2="698.11"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.06"
					y1="58.64"
					x2="698.11"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="739.9 53.68 735.84 53.68 735.84 58.64 739.9 58.64 739.9 53.68"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="739.9"
					y1="58.64"
					x2="739.9"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.84"
					y1="58.64"
					x2="739.9"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="735.84"
					y1="53.68"
					x2="735.84"
					y2="58.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.9"
					y1="53.68"
					x2="735.84"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="698.11"
					y1="54.58"
					x2="735.84"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="692.25 58.19 694.06 58.19 694.06 53.68 696.31 53.68 696.31 53.23 692.25 53.23 692.25 58.19"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.25"
					y1="53.23"
					x2="692.25"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.31"
					y1="53.23"
					x2="692.25"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="696.31"
					y1="53.68"
					x2="696.31"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.06"
					y1="53.68"
					x2="696.31"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="694.06"
					y1="58.19"
					x2="694.06"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.25"
					y1="58.19"
					x2="694.06"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="741.7 53.23 737.65 53.23 737.65 53.68 739.9 53.68 739.9 58.19 741.7 58.19 741.7 53.23"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="741.7"
					y1="58.19"
					x2="741.7"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.9"
					y1="58.19"
					x2="741.7"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="739.9"
					y1="53.68"
					x2="739.9"
					y2="58.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.65"
					y1="53.68"
					x2="739.9"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="737.65"
					y1="53.23"
					x2="737.65"
					y2="53.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.7"
					y1="53.23"
					x2="737.65"
					y2="53.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="743.99 54.58 743.99 56.87 837.8 56.87 837.8 54.58 743.99 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="837.8"
					y1="54.58"
					x2="743.99"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="837.8"
					y1="56.87"
					x2="837.8"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.99"
					y1="56.87"
					x2="837.8"
					y2="56.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="743.99"
					y1="54.58"
					x2="743.99"
					y2="56.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="692.25 54.58 692.25 68.32 687.68 68.32 687.68 54.58 692.25 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="692.25"
					y1="68.32"
					x2="692.25"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="68.32"
					x2="692.25"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="54.58"
					x2="687.68"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="692.25"
					y1="54.58"
					x2="687.68"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="746.28 54.58 746.28 68.32 741.7 68.32 741.7 54.58 746.28 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="746.28"
					y1="68.32"
					x2="746.28"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.7"
					y1="68.32"
					x2="746.28"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="741.7"
					y1="54.58"
					x2="741.7"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="746.28"
					y1="54.58"
					x2="741.7"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="840.09 54.58 840.09 68.32 835.51 68.32 835.51 54.58 840.09 54.58"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="840.09"
					y1="68.32"
					x2="840.09"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.51"
					y1="68.32"
					x2="840.09"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.51"
					y1="54.58"
					x2="835.51"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.09"
					y1="54.58"
					x2="835.51"
					y2="54.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 321.11 224.01 321.11 224.01 388.09 221.72 388.09 221.72 321.11"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="321.11"
					x2="224.01"
					y2="321.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="321.11"
					x2="224.01"
					y2="388.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="388.09"
					x2="221.72"
					y2="388.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="388.09"
					x2="221.72"
					y2="321.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 179.32 224.01 179.32 224.01 252.83 221.72 252.83 221.72 179.32"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="179.32"
					x2="224.01"
					y2="179.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="179.32"
					x2="224.01"
					y2="252.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="252.83"
					x2="221.72"
					y2="252.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="252.83"
					x2="221.72"
					y2="179.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 252.83 224.01 252.83 224.01 321.11 221.72 321.11 221.72 252.83"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="252.83"
					x2="224.01"
					y2="252.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="252.83"
					x2="224.01"
					y2="321.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="321.11"
					x2="221.72"
					y2="321.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="321.11"
					x2="221.72"
					y2="252.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="210 98.66 150.56 98.66 150.56 94.16 210 94.16 210 98.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="210"
					y1="98.66"
					x2="150.56"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.56"
					y1="98.66"
					x2="150.56"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.56"
					y1="94.16"
					x2="210"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210"
					y1="94.16"
					x2="210"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210"
					y1="95.06"
					x2="150.56"
					y2="95.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210"
					y1="94.16"
					x2="150.56"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210"
					y1="98.66"
					x2="150.56"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m220.82,175.23c-44.77,0-81.07-36.3-81.07-81.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.82 98.66 210 98.66 210 94.16 220.82 94.16 220.82 98.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.82"
					y1="98.66"
					x2="210"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210"
					y1="98.66"
					x2="210"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="210"
					y1="94.16"
					x2="220.82"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="94.16"
					x2="220.82"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="150.56 98.66 139.75 98.66 139.75 94.16 150.56 94.16 150.56 98.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="150.56"
					y1="98.66"
					x2="139.75"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.75"
					y1="98.66"
					x2="139.75"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="139.75"
					y1="94.16"
					x2="150.56"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="150.56"
					y1="94.16"
					x2="150.56"
					y2="98.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="225.77 92.36 225.77 96.41 225.32 96.41 225.32 94.16 220.82 94.16 220.82 92.36 225.77 92.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="225.77"
					y1="92.36"
					x2="225.77"
					y2="96.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="96.41"
					x2="225.32"
					y2="96.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="96.41"
					x2="225.32"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="94.16"
					x2="220.82"
					y2="94.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="94.16"
					x2="220.82"
					y2="92.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="92.36"
					x2="225.77"
					y2="92.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.82 177.03 220.82 175.23 225.32 175.23 225.32 172.97 225.77 172.97 225.77 177.03 220.82 177.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.82"
					y1="177.03"
					x2="220.82"
					y2="175.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="175.23"
					x2="225.32"
					y2="175.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="175.23"
					x2="225.32"
					y2="172.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="172.97"
					x2="225.77"
					y2="172.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="172.97"
					x2="225.77"
					y2="177.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="177.03"
					x2="220.82"
					y2="177.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 92.36 221.72 87.78 235.45 87.78 235.45 92.36 221.72 92.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="87.78"
					x2="221.72"
					y2="92.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="87.78"
					x2="221.72"
					y2="87.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="92.36"
					x2="235.45"
					y2="87.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="92.36"
					x2="235.45"
					y2="92.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 181.61 221.72 177.03 235.45 177.03 235.45 181.61 221.72 181.61"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="177.03"
					x2="221.72"
					y2="181.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="177.03"
					x2="221.72"
					y2="177.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="181.61"
					x2="235.45"
					y2="177.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="181.61"
					x2="235.45"
					y2="181.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 255.12 221.72 250.54 235.45 250.54 235.45 255.12 221.72 255.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="250.54"
					x2="221.72"
					y2="255.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="250.54"
					x2="221.72"
					y2="250.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="255.12"
					x2="235.45"
					y2="250.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="255.12"
					x2="235.45"
					y2="255.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 390.38 221.72 385.8 235.45 385.8 235.45 390.38 221.72 390.38"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="385.8"
					x2="221.72"
					y2="390.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="385.8"
					x2="221.72"
					y2="385.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="390.38"
					x2="235.45"
					y2="385.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="390.38"
					x2="235.45"
					y2="390.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 323.4 221.72 318.82 235.45 318.82 235.45 323.4 221.72 323.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="318.82"
					x2="221.72"
					y2="323.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="318.82"
					x2="221.72"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="323.4"
					x2="235.45"
					y2="318.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="323.4"
					x2="235.45"
					y2="323.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 541.57 224.01 541.57 224.01 635.07 221.72 635.07 221.72 541.57"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="541.57"
					x2="224.01"
					y2="541.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="541.57"
					x2="224.01"
					y2="635.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="224.01"
					y1="635.07"
					x2="221.72"
					y2="635.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="635.07"
					x2="221.72"
					y2="541.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.82 496.39 220.82 533.42 225.77 533.42 225.77 496.39 220.82 496.39"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="220.37 535.22 220.37 494.59 220.82 494.59 220.82 535.22 220.37 535.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.37"
					y1="535.22"
					x2="220.37"
					y2="494.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.37"
					y1="494.59"
					x2="220.82"
					y2="494.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="494.59"
					x2="220.82"
					y2="535.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="535.22"
					x2="220.37"
					y2="535.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="496.39"
					x2="225.77"
					y2="533.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="533.42"
					x2="220.82"
					y2="496.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="225.77 492.33 225.77 496.39 220.82 496.39 220.82 492.33 225.77 492.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="225.77"
					y1="492.33"
					x2="225.77"
					y2="496.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="496.39"
					x2="220.82"
					y2="496.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="496.39"
					x2="220.82"
					y2="492.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="492.33"
					x2="225.77"
					y2="492.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.82 537.48 220.82 533.42 225.77 533.42 225.77 537.48 220.82 537.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.82"
					y1="537.48"
					x2="220.82"
					y2="533.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="533.42"
					x2="225.77"
					y2="533.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="533.42"
					x2="225.77"
					y2="537.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.77"
					y1="537.48"
					x2="220.82"
					y2="537.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="496.39"
					x2="221.72"
					y2="533.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="225.32 490.53 225.32 492.33 220.82 492.33 220.82 494.59 220.37 494.59 220.37 490.53 225.32 490.53"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="225.32"
					y1="490.53"
					x2="225.32"
					y2="492.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="492.33"
					x2="220.82"
					y2="492.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="492.33"
					x2="220.82"
					y2="494.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="494.59"
					x2="220.37"
					y2="494.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.37"
					y1="494.59"
					x2="220.37"
					y2="490.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.37"
					y1="490.53"
					x2="225.32"
					y2="490.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="220.37 539.28 220.37 535.22 220.82 535.22 220.82 537.48 225.32 537.48 225.32 539.28 220.37 539.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="220.37"
					y1="539.28"
					x2="220.37"
					y2="535.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.37"
					y1="535.22"
					x2="220.82"
					y2="535.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="535.22"
					x2="220.82"
					y2="537.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="220.82"
					y1="537.48"
					x2="225.32"
					y2="537.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="537.48"
					x2="225.32"
					y2="539.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="225.32"
					y1="539.28"
					x2="220.37"
					y2="539.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 543.86 221.72 539.28 235.45 539.28 235.45 543.86 221.72 543.86"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="539.28"
					x2="221.72"
					y2="543.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="539.28"
					x2="221.72"
					y2="539.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="543.86"
					x2="235.45"
					y2="539.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="543.86"
					x2="235.45"
					y2="543.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 485.95 235.45 485.95 235.45 490.53 221.72 490.53 221.72 485.95"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="235.45"
					y1="485.95"
					x2="221.72"
					y2="485.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="490.53"
					x2="235.45"
					y2="485.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="490.53"
					x2="235.45"
					y2="490.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="485.95"
					x2="221.72"
					y2="490.53"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="221.72 637.36 221.72 632.78 235.45 632.78 235.45 637.36 221.72 637.36"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="221.72"
					y1="632.78"
					x2="221.72"
					y2="637.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="632.78"
					x2="221.72"
					y2="632.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="637.36"
					x2="235.45"
					y2="632.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="221.72"
					y1="637.36"
					x2="235.45"
					y2="637.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="857.28"
					y1="788"
					x2="875.6"
					y2="788"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="911.87"
					y1="788"
					x2="875.6"
					y2="788"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="911.87"
					y1="500.61"
					x2="911.87"
					y2="788"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="911.87"
					y1="500.61"
					x2="930.19"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="932.69"
					y1="500.61"
					x2="930.19"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="932.69"
					y1="361.74"
					x2="932.69"
					y2="414.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="932.69"
					y1="426.15"
					x2="932.69"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="840.09"
					y1="50"
					x2="840.09"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="217.14"
					y1="87.78"
					x2="235.45"
					y2="87.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="443.87"
					y1="860.12"
					x2="443.87"
					y2="715.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="948.86"
					x2="853.73"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="853.73"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="850.29"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="948.86"
					x2="759.86"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="759.86"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="763.3"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="710.93"
					y1="930.54"
					x2="639.72"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="930.54"
					x2="464.13"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="764.44 950 764.44 948.86 759.86 948.86 759.86 950 764.44 950"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="849.15 948.86 849.15 950 853.73 950 853.73 948.86 849.15 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="764.44 930.54 764.44 929.4 759.86 929.4 759.86 930.54 764.44 930.54"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="849.15 929.4 849.15 930.54 853.73 930.54 853.73 929.4 849.15 929.4"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="764.44"
					y1="950"
					x2="759.86"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.86"
					y1="950"
					x2="759.86"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.86"
					y1="948.86"
					x2="764.44"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.44"
					y1="948.86"
					x2="764.44"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.15"
					y1="948.86"
					x2="853.73"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.73"
					y1="948.86"
					x2="853.73"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.73"
					y1="950"
					x2="849.15"
					y2="950"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.15"
					y1="950"
					x2="849.15"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.44"
					y1="930.54"
					x2="759.86"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.86"
					y1="930.54"
					x2="759.86"
					y2="929.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="759.86"
					y1="929.4"
					x2="764.44"
					y2="929.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="764.44"
					y1="929.4"
					x2="764.44"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.15"
					y1="929.4"
					x2="853.73"
					y2="929.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.73"
					y1="929.4"
					x2="853.73"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.73"
					y1="930.54"
					x2="849.15"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.15"
					y1="930.54"
					x2="849.15"
					y2="929.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="765.59 948.86 765.59 930.54 763.87 930.54 763.87 948.86 765.59 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="849.72 948.86 849.72 930.54 848 930.54 848 948.86 849.72 948.86"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="789.73 872.27 786.89 875.1 845.17 933.38 848 930.54 789.73 872.27"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="763.87"
					y1="930.54"
					x2="763.3"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.87"
					y1="948.86"
					x2="763.3"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="763.3"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.72"
					y1="930.54"
					x2="850.29"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.72"
					y1="948.86"
					x2="850.29"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="850.29"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.59"
					y1="948.86"
					x2="765.59"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.59"
					y1="930.54"
					x2="763.87"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.87"
					y1="930.54"
					x2="763.87"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.87"
					y1="948.86"
					x2="765.59"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.72"
					y1="948.86"
					x2="849.72"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="849.72"
					y1="930.54"
					x2="848"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848"
					y1="930.54"
					x2="848"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848"
					y1="948.86"
					x2="849.72"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.73"
					y1="872.27"
					x2="786.89"
					y2="875.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="786.89"
					y1="875.1"
					x2="845.17"
					y2="933.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="845.17"
					y1="933.38"
					x2="848"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848"
					y1="930.54"
					x2="789.73"
					y2="872.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m765.59,930.54c0-20.47,7.62-40.21,21.38-55.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="763.3"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="763.3"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="759.86"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="930.54"
					x2="759.86"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="948.86"
					x2="759.86"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="763.3"
					y1="948.86"
					x2="759.86"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="850.29"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="850.29"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="853.73"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="930.54"
					x2="853.73"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="948.86"
					x2="853.73"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="850.29"
					y1="948.86"
					x2="853.73"
					y2="948.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="710.93"
					y1="855.74"
					x2="710.93"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="855.74"
					x2="709.66"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="709.66"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="706.22"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="855.74"
					x2="640.98"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="640.98"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="644.41"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="710.93"
					y1="844.29"
					x2="706.22"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="639.72"
					y1="855.74"
					x2="644.41"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="855.74"
					x2="710.93"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="645.56 856.88 645.56 855.74 640.98 855.74 640.98 856.88 645.56 856.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="705.08 855.74 705.08 856.88 709.66 856.88 709.66 855.74 705.08 855.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="645.56 844.29 645.56 843.15 640.98 843.15 640.98 844.29 645.56 844.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="705.08 843.15 705.08 844.29 709.66 844.29 709.66 843.15 705.08 843.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="645.56"
					y1="856.88"
					x2="640.98"
					y2="856.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.98"
					y1="856.88"
					x2="640.98"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.98"
					y1="855.74"
					x2="645.56"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.56"
					y1="855.74"
					x2="645.56"
					y2="856.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.08"
					y1="855.74"
					x2="709.66"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.66"
					y1="855.74"
					x2="709.66"
					y2="856.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.66"
					y1="856.88"
					x2="705.08"
					y2="856.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.08"
					y1="856.88"
					x2="705.08"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.56"
					y1="844.29"
					x2="640.98"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.98"
					y1="844.29"
					x2="640.98"
					y2="843.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="640.98"
					y1="843.15"
					x2="645.56"
					y2="843.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="645.56"
					y1="843.15"
					x2="645.56"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.08"
					y1="843.15"
					x2="709.66"
					y2="843.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.66"
					y1="843.15"
					x2="709.66"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="709.66"
					y1="844.29"
					x2="705.08"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.08"
					y1="844.29"
					x2="705.08"
					y2="843.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="646.7 855.74 646.7 844.29 644.99 844.29 644.99 855.74 646.7 855.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="705.65 855.74 705.65 844.29 703.93 844.29 703.93 855.74 705.65 855.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="663.46 803.82 660.63 806.66 701.1 847.13 703.93 844.29 663.46 803.82"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="644.99"
					y1="844.29"
					x2="644.41"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.99"
					y1="855.74"
					x2="644.41"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="644.41"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.65"
					y1="844.29"
					x2="706.22"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.65"
					y1="855.74"
					x2="706.22"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="706.22"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.7"
					y1="855.74"
					x2="646.7"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="646.7"
					y1="844.29"
					x2="644.99"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.99"
					y1="844.29"
					x2="644.99"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.99"
					y1="855.74"
					x2="646.7"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.65"
					y1="855.74"
					x2="705.65"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="705.65"
					y1="844.29"
					x2="703.93"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.93"
					y1="844.29"
					x2="703.93"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.93"
					y1="855.74"
					x2="705.65"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="663.46"
					y1="803.82"
					x2="660.63"
					y2="806.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="660.63"
					y1="806.66"
					x2="701.1"
					y2="847.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="701.1"
					y1="847.13"
					x2="703.93"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.93"
					y1="844.29"
					x2="663.46"
					y2="803.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m646.7,844.29c0-13.8,4.98-27.12,14.03-37.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="644.41"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="644.41"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="640.98"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="844.29"
					x2="640.98"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="855.74"
					x2="640.98"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="644.41"
					y1="855.74"
					x2="640.98"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="706.22"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="706.22"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="709.66"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="844.29"
					x2="709.66"
					y2="844.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="855.74"
					x2="709.66"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="706.22"
					y1="855.74"
					x2="709.66"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="639.72"
					y1="930.54"
					x2="639.72"
					y2="855.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="609.93"
					y1="725.31"
					x2="609.93"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="598.49"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="609.93"
					y2="725.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="527.71"
					x2="598.49"
					y2="652.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="609.93 726.46 611.08 726.46 611.08 721.88 609.93 721.88 609.93 726.46"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="597.34 726.46 598.49 726.46 598.49 721.88 597.34 721.88 597.34 726.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="609.93"
					y1="726.46"
					x2="609.93"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.93"
					y1="721.88"
					x2="611.08"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.08"
					y1="721.88"
					x2="611.08"
					y2="726.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="611.08"
					y1="726.46"
					x2="609.93"
					y2="726.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="815.74"
					x2="597.34"
					y2="815.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.34"
					y1="726.46"
					x2="597.34"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="597.34"
					y1="721.88"
					x2="598.49"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="721.88"
					x2="598.49"
					y2="726.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="726.46"
					x2="597.34"
					y2="726.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="609.93 725.88 598.49 725.88 598.49 727.6 609.93 727.6 609.93 725.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="540.21 785.88 543.04 788.71 601.32 730.44 598.49 727.6 540.21 785.88"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="598.49"
					y1="725.88"
					x2="598.49"
					y2="725.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.93"
					y1="725.88"
					x2="609.93"
					y2="725.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="609.93"
					y2="725.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.93"
					y1="725.88"
					x2="598.49"
					y2="725.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="725.88"
					x2="598.49"
					y2="727.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="727.6"
					x2="609.93"
					y2="727.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="609.93"
					y1="727.6"
					x2="609.93"
					y2="725.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.21"
					y1="785.88"
					x2="543.04"
					y2="788.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="543.04"
					y1="788.71"
					x2="601.32"
					y2="730.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="601.32"
					y1="730.44"
					x2="598.49"
					y2="727.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="727.6"
					x2="540.21"
					y2="785.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="609.93"
					y2="725.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="609.93"
					y2="725.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="598.49"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="725.31"
					x2="598.49"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="609.93"
					y1="725.31"
					x2="609.93"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="609.93"
					y1="725.31"
					x2="609.93"
					y2="721.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="488.15"
					y1="401.18"
					x2="485.72"
					y2="398.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="477.63"
					y2="406.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="488.15"
					y2="401.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="542"
					y1="455.03"
					x2="544.43"
					y2="457.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="536.33"
					y2="465.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="542"
					y2="455.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="488.15"
					y1="401.18"
					x2="481.58"
					y2="394.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="476.84"
					y1="406.06"
					x2="480.05"
					y2="409.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="537.18"
					y2="466.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="542 453.42 541.19 454.22 544.43 457.46 545.24 456.65 542 453.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="488.96 401.99 489.77 401.18 486.53 397.94 485.72 398.75 488.96 401.99"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="533.1 462.32 532.29 463.13 535.53 466.37 536.33 465.56 533.1 462.32"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="480.05 410.89 480.86 410.08 477.63 406.85 476.81 407.66 480.05 410.89"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="542"
					y1="453.42"
					x2="545.24"
					y2="456.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.24"
					y1="456.65"
					x2="544.43"
					y2="457.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="544.43"
					y1="457.46"
					x2="541.19"
					y2="454.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.19"
					y1="454.22"
					x2="542"
					y2="453.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.96"
					y1="401.99"
					x2="485.72"
					y2="398.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.72"
					y1="398.75"
					x2="486.53"
					y2="397.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.53"
					y1="397.94"
					x2="489.77"
					y2="401.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.77"
					y1="401.18"
					x2="488.96"
					y2="401.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.1"
					y1="462.32"
					x2="536.33"
					y2="465.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="536.33"
					y1="465.56"
					x2="535.53"
					y2="466.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="535.53"
					y1="466.37"
					x2="532.29"
					y2="463.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.29"
					y1="463.13"
					x2="533.1"
					y2="462.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.05"
					y1="410.89"
					x2="476.81"
					y2="407.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.81"
					y1="407.66"
					x2="477.63"
					y2="406.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="477.63"
					y1="406.85"
					x2="480.86"
					y2="410.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.86"
					y1="410.08"
					x2="480.05"
					y2="410.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="540.38 453.42 532.29 461.51 533.5 462.73 541.6 454.63 540.38 453.42"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="488.55 401.59 480.46 409.68 481.67 410.89 489.77 402.8 488.55 401.59"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="481.67 482.48 485.68 482.48 485.68 410.89 481.67 410.89 481.67 482.48"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="533.5"
					y1="462.73"
					x2="533.91"
					y2="463.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.6"
					y1="454.63"
					x2="542"
					y2="455.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="542"
					y2="455.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.46"
					y1="409.68"
					x2="480.05"
					y2="409.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.55"
					y1="401.59"
					x2="488.15"
					y2="401.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="488.15"
					y2="401.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="540.38"
					y1="453.42"
					x2="532.29"
					y2="461.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="532.29"
					y1="461.51"
					x2="533.5"
					y2="462.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.5"
					y1="462.73"
					x2="541.6"
					y2="454.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.6"
					y1="454.63"
					x2="540.38"
					y2="453.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="488.55"
					y1="401.59"
					x2="480.46"
					y2="409.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.46"
					y1="409.68"
					x2="481.67"
					y2="410.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.67"
					y1="410.89"
					x2="489.77"
					y2="402.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.77"
					y1="402.8"
					x2="488.55"
					y2="401.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.67"
					y1="482.48"
					x2="485.68"
					y2="482.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.68"
					y1="482.48"
					x2="485.68"
					y2="410.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="485.68"
					y1="410.89"
					x2="481.67"
					y2="410.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.67"
					y1="410.89"
					x2="481.67"
					y2="482.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="542"
					y2="455.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="542"
					y2="455.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="536.33"
					y2="465.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="533.91"
					y1="463.13"
					x2="536.33"
					y2="465.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="542"
					y1="455.03"
					x2="544.43"
					y2="457.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="542"
					y1="455.03"
					x2="544.43"
					y2="457.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="488.15"
					y2="401.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="488.15"
					y2="401.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="477.63"
					y2="406.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="480.05"
					y1="409.28"
					x2="477.63"
					y2="406.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="488.15"
					y1="401.18"
					x2="485.72"
					y2="398.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="488.15"
					y1="401.18"
					x2="485.72"
					y2="398.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="642.38"
					x2="548.63"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.34"
					y1="642.38"
					x2="548.63"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="537.18"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="546.34"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="508.45"
					x2="548.63"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.34"
					y1="508.45"
					x2="548.63"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="508.45"
					x2="537.18"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="508.45"
					x2="546.34"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="537.18"
					y2="652.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="652.19"
					x2="548.63"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="546.34 510.17 548.63 510.17 548.63 509.02 546.34 509.02 546.34 510.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="549.77 510.17 549.77 505.59 548.63 505.59 548.63 510.17 549.77 510.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="546.34 641.81 548.63 641.81 548.63 640.66 546.34 640.66 546.34 641.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="548.63 640.66 548.63 645.24 549.77 645.24 549.77 640.66 548.63 640.66"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="537.18 510.17 537.18 505.59 534.32 505.59 534.32 510.17 537.18 510.17"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="534.32 640.66 534.32 645.24 537.18 645.24 537.18 640.66 534.32 640.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="546.34"
					y1="510.17"
					x2="548.63"
					y2="510.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="510.17"
					x2="548.63"
					y2="509.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="509.02"
					x2="546.34"
					y2="509.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="509.02"
					x2="546.34"
					y2="510.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.77"
					y1="510.17"
					x2="549.77"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.77"
					y1="505.59"
					x2="548.63"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="505.59"
					x2="548.63"
					y2="510.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="510.17"
					x2="549.77"
					y2="510.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="641.81"
					x2="548.63"
					y2="641.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="641.81"
					x2="548.63"
					y2="640.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="640.66"
					x2="546.34"
					y2="640.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="640.66"
					x2="546.34"
					y2="641.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="640.66"
					x2="548.63"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="548.63"
					y1="645.24"
					x2="549.77"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.77"
					y1="645.24"
					x2="549.77"
					y2="640.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="549.77"
					y1="640.66"
					x2="548.63"
					y2="640.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="510.17"
					x2="537.18"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="505.59"
					x2="534.32"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="505.59"
					x2="534.32"
					y2="510.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="510.17"
					x2="537.18"
					y2="510.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="640.66"
					x2="534.32"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="534.32"
					y1="645.24"
					x2="537.18"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="645.24"
					x2="537.18"
					y2="640.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="640.66"
					x2="534.32"
					y2="640.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="546.34 513.6 546.34 509.02 537.18 509.02 537.18 513.6 546.34 513.6"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="546.34 641.81 546.34 637.23 537.18 637.23 537.18 641.81 546.34 641.81"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="537.18 573.13 537.18 637.23 541.19 637.23 541.19 573.13 537.18 573.13"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="541.19 541.07 541.19 605.18 545.19 605.18 545.19 541.07 541.19 541.07"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="537.18"
					y1="509.02"
					x2="537.18"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="509.02"
					x2="546.34"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="508.45"
					x2="546.34"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="641.81"
					x2="537.18"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="641.81"
					x2="546.34"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="546.34"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="513.6"
					x2="537.18"
					y2="513.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="513.6"
					x2="537.18"
					y2="509.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="509.02"
					x2="546.34"
					y2="509.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="509.02"
					x2="546.34"
					y2="513.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="641.81"
					x2="537.18"
					y2="641.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="641.81"
					x2="537.18"
					y2="637.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="637.23"
					x2="546.34"
					y2="637.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="546.34"
					y1="637.23"
					x2="546.34"
					y2="641.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="573.13"
					x2="541.19"
					y2="573.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.19"
					y1="573.13"
					x2="541.19"
					y2="637.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.19"
					y1="637.23"
					x2="537.18"
					y2="637.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="637.23"
					x2="537.18"
					y2="573.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.19"
					y1="541.07"
					x2="545.19"
					y2="541.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.19"
					y1="541.07"
					x2="545.19"
					y2="605.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="545.19"
					y1="605.18"
					x2="541.19"
					y2="605.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="541.19"
					y1="605.18"
					x2="541.19"
					y2="541.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="537.18"
					y1="508.45"
					x2="546.34"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="508.45"
					x2="546.34"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.34"
					y1="508.45"
					x2="548.63"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="508.45"
					x2="537.18"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.34"
					y1="508.45"
					x2="548.63"
					y2="508.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="508.45"
					x2="548.63"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="508.45"
					x2="548.63"
					y2="505.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="546.34"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="546.34"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.34"
					y1="642.38"
					x2="548.63"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="642.38"
					x2="537.18"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="546.34"
					y1="642.38"
					x2="548.63"
					y2="642.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="642.38"
					x2="548.63"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="548.63"
					y1="642.38"
					x2="548.63"
					y2="645.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="598.49"
					y1="652.19"
					x2="548.63"
					y2="652.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="537.18"
					y1="652.19"
					x2="533.55"
					y2="652.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="481.58"
					y1="394.62"
					x2="465.4"
					y2="394.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="633.02"
					y1="315.17"
					x2="630.59"
					y2="312.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="638.69"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="633.02"
					y2="315.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="633.83 315.98 630.59 312.74 629.78 313.55 633.02 316.79 633.83 315.98"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="642.74 307.08 639.5 303.84 638.69 304.65 641.92 307.89 642.74 307.08"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="690.49"
					y1="372.64"
					x2="689.68"
					y2="373.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.83"
					y1="315.98"
					x2="630.59"
					y2="312.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="630.59"
					y1="312.74"
					x2="629.78"
					y2="313.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="629.78"
					y1="313.55"
					x2="633.02"
					y2="316.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.02"
					y1="316.79"
					x2="633.83"
					y2="315.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.74"
					y1="307.08"
					x2="639.5"
					y2="303.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="639.5"
					y1="303.84"
					x2="638.69"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="638.69"
					y1="304.65"
					x2="641.92"
					y2="307.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.92"
					y1="307.89"
					x2="642.74"
					y2="307.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="633.43 315.58 634.64 316.79 642.74 308.7 641.52 307.48 633.43 315.58"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="720.57 308.7 642.74 308.7 642.74 312.7 720.57 312.7 720.57 308.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="690.89"
					y1="373.04"
					x2="691.3"
					y2="373.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.52"
					y1="307.48"
					x2="641.12"
					y2="307.08"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.43"
					y1="315.58"
					x2="633.02"
					y2="315.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="633.02"
					y2="315.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="690.89"
					y1="373.04"
					x2="689.68"
					y2="371.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="633.43"
					y1="315.58"
					x2="641.52"
					y2="307.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.52"
					y1="307.48"
					x2="642.74"
					y2="308.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.74"
					y1="308.7"
					x2="634.64"
					y2="316.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="634.64"
					y1="316.79"
					x2="633.43"
					y2="315.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.57"
					y1="308.7"
					x2="720.57"
					y2="312.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="720.57"
					y1="312.7"
					x2="642.74"
					y2="312.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.74"
					y1="312.7"
					x2="642.74"
					y2="308.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="642.74"
					y1="308.7"
					x2="720.57"
					y2="308.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="633.02"
					y2="315.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="633.02"
					y2="315.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="638.69"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="641.12"
					y1="307.08"
					x2="638.69"
					y2="304.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="633.02"
					y1="315.17"
					x2="630.59"
					y2="312.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="633.02"
					y1="315.17"
					x2="630.59"
					y2="312.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="361.74"
					x2="924.53"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="359.45"
					x2="921.67"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="350.29"
					x2="924.53"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="350.29"
					x2="921.67"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="361.74"
					x2="784.88"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="359.45"
					x2="787.74"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="350.29"
					x2="784.88"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="350.29"
					x2="787.74"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="932.69"
					y1="350.29"
					x2="921.67"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="350.29"
					x2="776.06"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="780.8"
					y1="361.74"
					x2="787.74"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="361.74"
					x2="932.69"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="789.46 359.45 788.31 359.45 788.31 361.74 789.46 361.74 789.46 359.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="789.46 362.88 789.46 361.74 784.88 361.74 784.88 362.88 789.46 362.88"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="921.09 359.45 919.95 359.45 919.95 361.74 921.09 361.74 921.09 359.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="919.95 361.74 919.95 362.88 924.53 362.88 924.53 361.74 919.95 361.74"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="789.46 350.29 789.46 347.43 784.88 347.43 784.88 350.29 789.46 350.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="919.95 347.43 919.95 350.29 924.53 350.29 924.53 347.43 919.95 347.43"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="789.46"
					y1="359.45"
					x2="789.46"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.46"
					y1="361.74"
					x2="788.31"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="361.74"
					x2="788.31"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="359.45"
					x2="789.46"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.46"
					y1="362.88"
					x2="784.88"
					y2="362.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.88"
					y1="362.88"
					x2="784.88"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.88"
					y1="361.74"
					x2="789.46"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.46"
					y1="361.74"
					x2="789.46"
					y2="362.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.09"
					y1="359.45"
					x2="921.09"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.09"
					y1="361.74"
					x2="919.95"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.95"
					y1="361.74"
					x2="919.95"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.95"
					y1="359.45"
					x2="921.09"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.95"
					y1="361.74"
					x2="924.53"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.53"
					y1="361.74"
					x2="924.53"
					y2="362.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.53"
					y1="362.88"
					x2="919.95"
					y2="362.88"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.95"
					y1="362.88"
					x2="919.95"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.46"
					y1="350.29"
					x2="784.88"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.88"
					y1="350.29"
					x2="784.88"
					y2="347.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="784.88"
					y1="347.43"
					x2="789.46"
					y2="347.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="789.46"
					y1="347.43"
					x2="789.46"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.95"
					y1="347.43"
					x2="924.53"
					y2="347.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.53"
					y1="347.43"
					x2="924.53"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="924.53"
					y1="350.29"
					x2="919.95"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="919.95"
					y1="350.29"
					x2="919.95"
					y2="347.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="792.89 350.29 788.31 350.29 788.31 359.45 792.89 359.45 792.89 350.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="921.09 350.29 916.52 350.29 916.52 359.45 921.09 359.45 921.09 350.29"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="852.41 359.45 916.52 359.45 916.52 355.44 852.41 355.44 852.41 359.45"
					fill="none"
					fillRule="evenodd"
				/>
				<polyline
					points="820.36 355.44 884.46 355.44 884.46 351.43 820.36 351.43 820.36 355.44"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="788.31"
					y1="359.45"
					x2="787.74"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="350.29"
					x2="787.74"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.74"
					y1="359.45"
					x2="787.74"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.09"
					y1="359.45"
					x2="921.67"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.09"
					y1="350.29"
					x2="921.67"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.67"
					y1="359.45"
					x2="921.67"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.89"
					y1="350.29"
					x2="792.89"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="792.89"
					y1="359.45"
					x2="788.31"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="359.45"
					x2="788.31"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="788.31"
					y1="350.29"
					x2="792.89"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.09"
					y1="350.29"
					x2="921.09"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="921.09"
					y1="359.45"
					x2="916.52"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.52"
					y1="359.45"
					x2="916.52"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.52"
					y1="350.29"
					x2="921.09"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.41"
					y1="359.45"
					x2="852.41"
					y2="355.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.41"
					y1="355.44"
					x2="916.52"
					y2="355.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.52"
					y1="355.44"
					x2="916.52"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="916.52"
					y1="359.45"
					x2="852.41"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.36"
					y1="355.44"
					x2="820.36"
					y2="351.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="820.36"
					y1="351.43"
					x2="884.46"
					y2="351.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.46"
					y1="351.43"
					x2="884.46"
					y2="355.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.46"
					y1="355.44"
					x2="820.36"
					y2="355.44"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="787.74"
					y1="350.29"
					x2="787.74"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="350.29"
					x2="787.74"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="359.45"
					x2="787.74"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="350.29"
					x2="784.88"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="359.45"
					x2="787.74"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="361.74"
					x2="784.88"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="787.74"
					y1="361.74"
					x2="784.88"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="350.29"
					x2="921.67"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="350.29"
					x2="921.67"
					y2="359.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="359.45"
					x2="921.67"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="350.29"
					x2="924.53"
					y2="350.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="359.45"
					x2="921.67"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="361.74"
					x2="924.53"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="921.67"
					y1="361.74"
					x2="924.53"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="776.06"
					y1="350.29"
					x2="764.61"
					y2="361.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="53.58 679.01 49 679.01 49 188.23 53.58 188.3 53.58 679.01"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="53.58"
					y1="679.01"
					x2="53.58"
					y2="188.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="49"
					y1="188.23"
					x2="49"
					y2="679.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="49"
					y1="679.01"
					x2="53.58"
					y2="679.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<polyline
					points="163.09 74.14 163.16 78.71 152.52 79.54 142.01 81.36 131.72 84.16 121.73 87.92 112.15 92.61 103.05 98.18 94.52 104.58 86.63 111.76 79.45 119.66 73.04 128.19 67.47 137.29 62.79 146.87 59.02 156.85 56.22 167.15 54.4 177.66 53.58 188.3 49 188.23 49.85 177.15 51.74 166.2 54.65 155.48 58.57 145.09 63.45 135.11 69.25 125.63 75.91 116.74 83.39 108.53 91.61 101.05 100.49 94.38 109.97 88.59 119.95 83.71 130.35 79.79 141.07 76.88 152.01 74.99 163.09 74.14"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m49,188.23c1.83-62.24,51.85-112.27,114.09-114.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<path
					d="m53.58,188.3c1.79-59.76,49.82-107.79,109.58-109.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<polyline
					points="163.16 78.71 163.09 74.14 217.14 74.14 217.14 78.71 163.16 78.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="163.16"
					y1="78.71"
					x2="217.14"
					y2="78.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="217.14"
					y1="78.71"
					x2="217.14"
					y2="74.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="217.14"
					y1="74.14"
					x2="163.09"
					y2="74.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".13"
				/>
				<line
					x1="371.41"
					y1="50"
					x2="371.41"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="551.35"
					y1="50"
					x2="551.35"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="680.83"
					y1="68.32"
					x2="687.68"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="687.68"
					y1="68.32"
					x2="687.68"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="217.14"
					y1="485.95"
					x2="235.45"
					y2="485.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="235.45"
					y1="485.95"
					x2="235.45"
					y2="456.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="235.45"
					y1="394.62"
					x2="235.45"
					y2="390.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="235.45"
					y1="390.38"
					x2="217.14"
					y2="390.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="464.13"
					y1="930.54"
					x2="464.13"
					y2="860.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="464.13"
					y1="860.12"
					x2="452.69"
					y2="860.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="452.69"
					y1="860.12"
					x2="443.87"
					y2="860.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="235.45"
					y1="637.36"
					x2="217.14"
					y2="637.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="49"
					y1="679.01"
					x2="49"
					y2="690.45"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="49"
					y1="711.66"
					x2="49"
					y2="693.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<line
					x1="49"
					y1="690.45"
					x2="49"
					y2="693.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".34"
				/>
				<polyline
					points="464.13 860.12 464.13 930.54 598.49 930.54 598.49 860.12 464.13 860.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="598.49"
					y1="860.12"
					x2="464.13"
					y2="860.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="598.49"
					y1="930.54"
					x2="598.49"
					y2="860.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.13"
					y1="930.54"
					x2="598.49"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="464.13"
					y1="860.12"
					x2="464.13"
					y2="930.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="472.55 868.46 472.55 921.28 589.49 921.28 589.49 868.46 472.55 868.46"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="589.49"
					y1="868.46"
					x2="472.55"
					y2="868.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="589.49"
					y1="921.28"
					x2="589.49"
					y2="868.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.55"
					y1="921.28"
					x2="589.49"
					y2="921.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="472.55"
					y1="868.46"
					x2="472.55"
					y2="921.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="484.04 895.33 484 894.86 483.88 894.4 483.7 893.97 483.44 893.58 483.13 893.24 482.76 892.97 482.35 892.77 481.92 892.64 481.47 892.6 481.03 892.64 480.6 892.77 480.19 892.97 479.83 893.24 479.51 893.58 479.26 893.97 479.06 894.4 478.95 894.86 478.91 895.33 478.95 895.81 479.06 896.27 479.26 896.7 479.51 897.09 479.83 897.43 480.19 897.7 480.6 897.9 481.03 898.02 481.47 898.06 481.92 898.02 482.35 897.9 482.76 897.7 483.13 897.43 483.44 897.09 483.7 896.7 483.88 896.27 484 895.81 484.04 895.33"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="484"
					y1="895.81"
					x2="484.04"
					y2="895.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.88"
					y1="896.27"
					x2="484"
					y2="895.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.7"
					y1="896.7"
					x2="483.88"
					y2="896.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.44"
					y1="897.09"
					x2="483.7"
					y2="896.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.13"
					y1="897.43"
					x2="483.44"
					y2="897.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.76"
					y1="897.7"
					x2="483.13"
					y2="897.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.35"
					y1="897.9"
					x2="482.76"
					y2="897.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.92"
					y1="898.02"
					x2="482.35"
					y2="897.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.47"
					y1="898.06"
					x2="481.92"
					y2="898.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.03"
					y1="898.02"
					x2="481.47"
					y2="898.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.6"
					y1="897.9"
					x2="481.03"
					y2="898.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.19"
					y1="897.7"
					x2="480.6"
					y2="897.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.83"
					y1="897.43"
					x2="480.19"
					y2="897.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.51"
					y1="897.09"
					x2="479.83"
					y2="897.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.26"
					y1="896.7"
					x2="479.51"
					y2="897.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.06"
					y1="896.27"
					x2="479.26"
					y2="896.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.95"
					y1="895.81"
					x2="479.06"
					y2="896.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.91"
					y1="895.33"
					x2="478.95"
					y2="895.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.95"
					y1="894.86"
					x2="478.91"
					y2="895.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.06"
					y1="894.4"
					x2="478.95"
					y2="894.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.26"
					y1="893.97"
					x2="479.06"
					y2="894.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.51"
					y1="893.58"
					x2="479.26"
					y2="893.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="479.83"
					y1="893.24"
					x2="479.51"
					y2="893.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.19"
					y1="892.97"
					x2="479.83"
					y2="893.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.6"
					y1="892.77"
					x2="480.19"
					y2="892.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.03"
					y1="892.64"
					x2="480.6"
					y2="892.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.47"
					y1="892.6"
					x2="481.03"
					y2="892.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="481.92"
					y1="892.64"
					x2="481.47"
					y2="892.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.35"
					y1="892.77"
					x2="481.92"
					y2="892.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="482.76"
					y1="892.97"
					x2="482.35"
					y2="892.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.13"
					y1="893.24"
					x2="482.76"
					y2="892.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.44"
					y1="893.58"
					x2="483.13"
					y2="893.24"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.7"
					y1="893.97"
					x2="483.44"
					y2="893.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.88"
					y1="894.4"
					x2="483.7"
					y2="893.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484"
					y1="894.86"
					x2="483.88"
					y2="894.4"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="484.04"
					y1="895.33"
					x2="484"
					y2="894.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="469.55 897.69 469.16 897.65 468.79 897.55 468.44 897.37 468.12 897.14 467.85 896.85 467.63 896.51 467.47 896.14 467.37 895.74 467.34 895.33 467.37 894.92 467.47 894.53 467.63 894.15 467.85 893.82 468.12 893.53 468.44 893.29 468.79 893.12 469.16 893.01 469.55 892.98 473.26 893.35 473.56 893.41 473.84 893.51 474.1 893.66 478.79 894.29 478.95 894.32 479.11 894.39 479.26 894.48 479.38 894.6 479.49 894.74 479.57 894.9 479.63 895.07 479.65 895.24 479.65 895.42 479.63 895.6 479.57 895.77 479.49 895.93 479.38 896.06 479.26 896.18 479.11 896.28 478.95 896.34 478.79 896.38 474.1 897 473.84 897.16 473.56 897.26 473.26 897.31 469.55 897.69"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="469.55"
					y1="897.69"
					x2="473.26"
					y2="897.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="474.1"
					y1="897"
					x2="478.79"
					y2="896.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.79"
					y1="894.29"
					x2="474.1"
					y2="893.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.26"
					y1="893.35"
					x2="469.55"
					y2="892.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.75"
					y1="894.05"
					x2="473.07"
					y2="894.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="473.07"
					y1="896.61"
					x2="471.75"
					y2="896.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.75"
					y1="896.61"
					x2="471.75"
					y2="894.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m474.1,897c-.25.17-.54.28-.84.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m478.79,894.29c.49.07.87.51.87,1.05s-.37.98-.87,1.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m473.26,893.35c.3.03.59.13.84.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m469.55,897.69c-1.22,0-2.22-1.06-2.22-2.36s.99-2.36,2.22-2.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m473.07,894.05c.67,0,1.21.57,1.21,1.28s-.54,1.28-1.21,1.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m474.1,893.66c.53.36.86,1,.86,1.67s-.32,1.3-.86,1.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="503.99 765.66 505.81 761.57 506.44 757.14 505.81 752.71 503.99 748.63 501.67 745.94 498.77 743.9 491.96 741.3 486.3 740.39 480.58 740.73 475.07 742.31 470.04 742.18 465.16 740.91 460.7 738.55 458.77 737.32 454.79 735.87 450.56 736.09 448.89 736.74 444.45 736.74 444.45 738.6 446.47 738.6 444.6 741.7 443.87 745.25 443.87 769.03 445.11 773.63 448.38 777.08 452.9 778.56 453.45 778.56 456.31 778.09 460.81 775.68 465.21 773.34 470.04 772.08 475.02 771.95 480.54 773.55 486.28 773.9 491.96 772.98 498.77 770.39 501.67 768.35 503.99 765.66"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="465.01"
					y1="748.67"
					x2="465.01"
					y2="765.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.87"
					y1="769.03"
					x2="443.87"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.73"
					y1="769.03"
					x2="444.73"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.87"
					y1="745.25"
					x2="443.87"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.73"
					y1="745.25"
					x2="444.73"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.01"
					y1="765.18"
					x2="461.84"
					y2="765.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.84"
					y1="765.18"
					x2="461.84"
					y2="762.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.84"
					y1="762.56"
					x2="465.01"
					y2="762.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.01"
					y1="749.11"
					x2="461.84"
					y2="749.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.84"
					y1="749.11"
					x2="461.84"
					y2="751.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.84"
					y1="751.73"
					x2="465.01"
					y2="751.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.32"
					y1="738.6"
					x2="444.45"
					y2="738.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.32"
					y1="736.74"
					x2="444.45"
					y2="736.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.45"
					y1="736.74"
					x2="444.45"
					y2="738.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.32"
					y1="736.74"
					x2="452.32"
					y2="738.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.44"
					y1="757.14"
					x2="506.12"
					y2="759.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.12"
					y1="759.98"
					x2="505.39"
					y2="762.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.39"
					y1="762.73"
					x2="503.99"
					y2="765.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.99"
					y1="765.66"
					x2="501.68"
					y2="768.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.68"
					y1="768.35"
					x2="498.77"
					y2="770.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.77"
					y1="770.39"
					x2="495.47"
					y2="771.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.47"
					y1="771.89"
					x2="491.96"
					y2="772.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.96"
					y1="772.98"
					x2="486.29"
					y2="773.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.29"
					y1="773.97"
					x2="483.43"
					y2="774.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.43"
					y1="774.02"
					x2="480.58"
					y2="773.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.58"
					y1="773.7"
					x2="476.16"
					y2="772.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.16"
					y1="772.42"
					x2="471.88"
					y2="770.41"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.88"
					y1="770.41"
					x2="468.06"
					y2="768.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.06"
					y1="768.03"
					x2="465.01"
					y2="765.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.02"
					y1="771.95"
					x2="471.05"
					y2="771.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.05"
					y1="771.97"
					x2="467.18"
					y2="772.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.18"
					y1="772.63"
					x2="465.11"
					y2="773.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="465.11"
					y1="773.3"
					x2="463.05"
					y2="774.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.05"
					y1="774.27"
					x2="460.05"
					y2="776.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.05"
					y1="776.18"
					x2="456.95"
					y2="777.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.95"
					y1="777.86"
					x2="453.91"
					y2="778.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.91"
					y1="778.54"
					x2="450.89"
					y2="778.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.89"
					y1="778.29"
					x2="448.15"
					y2="777.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.15"
					y1="777.11"
					x2="445.94"
					y2="775.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.94"
					y1="775.03"
					x2="444.82"
					y2="773"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.82"
					y1="773"
					x2="444.19"
					y2="771.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.19"
					y1="771.06"
					x2="443.87"
					y2="769.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.73"
					y1="769.03"
					x2="444.81"
					y2="769.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.81"
					y1="769.94"
					x2="445.39"
					y2="771.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.39"
					y1="771.81"
					x2="446.79"
					y2="773.46"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.79"
					y1="773.46"
					x2="448.72"
					y2="774.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.72"
					y1="774.5"
					x2="451.28"
					y2="774.99"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.28"
					y1="774.99"
					x2="453.91"
					y2="775.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.91"
					y1="775.1"
					x2="455.21"
					y2="775.09"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="775.09"
					x2="456.25"
					y2="774.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.25"
					y1="774.54"
					x2="456.55"
					y2="773.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.55"
					y1="773.89"
					x2="458.6"
					y2="766.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.6"
					y1="766.7"
					x2="459.21"
					y2="763.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.21"
					y1="763.12"
					x2="459.47"
					y2="759.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.47"
					y1="759.51"
					x2="459.47"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="475.07"
					y1="742.31"
					x2="471.09"
					y2="742.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.09"
					y1="742.28"
					x2="467.21"
					y2="741.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="467.21"
					y1="741.63"
					x2="463.05"
					y2="740.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="463.05"
					y1="740.02"
					x2="460.04"
					y2="738.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.04"
					y1="738.12"
					x2="456.95"
					y2="736.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.95"
					y1="736.42"
					x2="454.92"
					y2="735.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="454.92"
					y1="735.86"
					x2="452.84"
					y2="735.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.84"
					y1="735.73"
					x2="450.8"
					y2="736.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.8"
					y1="736.02"
					x2="448.89"
					y2="736.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.73"
					y1="745.25"
					x2="444.81"
					y2="744.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.81"
					y1="744.34"
					x2="445.39"
					y2="742.48"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.39"
					y1="742.48"
					x2="446.79"
					y2="740.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.79"
					y1="740.82"
					x2="448.72"
					y2="739.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.72"
					y1="739.79"
					x2="451.28"
					y2="739.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.28"
					y1="739.3"
					x2="453.91"
					y2="739.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="453.91"
					y1="739.18"
					x2="455.21"
					y2="739.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.21"
					y1="739.2"
					x2="456.25"
					y2="739.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.25"
					y1="739.75"
					x2="456.55"
					y2="740.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="456.55"
					y1="740.39"
					x2="458.6"
					y2="747.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.6"
					y1="747.59"
					x2="459.21"
					y2="751.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.21"
					y1="751.16"
					x2="459.47"
					y2="754.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.47"
					y1="754.78"
					x2="459.47"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.44"
					y1="757.14"
					x2="506.12"
					y2="754.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="506.12"
					y1="754.3"
					x2="505.39"
					y2="751.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="505.39"
					y1="751.55"
					x2="503.99"
					y2="748.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="503.99"
					y1="748.63"
					x2="501.68"
					y2="745.94"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="501.68"
					y1="745.94"
					x2="498.77"
					y2="743.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="498.77"
					y1="743.9"
					x2="495.47"
					y2="742.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="495.47"
					y1="742.39"
					x2="491.96"
					y2="741.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="491.96"
					y1="741.3"
					x2="486.29"
					y2="740.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="486.29"
					y1="740.31"
					x2="483.43"
					y2="740.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="483.43"
					y1="740.26"
					x2="480.58"
					y2="740.58"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.58"
					y1="740.58"
					x2="476.16"
					y2="741.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="476.16"
					y1="741.87"
					x2="471.88"
					y2="743.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="471.88"
					y1="743.87"
					x2="468.06"
					y2="746.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="468.06"
					y1="746.25"
					x2="465.01"
					y2="748.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.59"
					y1="777.07"
					x2="459.24"
					y2="776.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.24"
					y1="776.61"
					x2="460.21"
					y2="775.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.21"
					y1="775.31"
					x2="460.43"
					y2="774.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.43"
					y1="774.17"
					x2="461.05"
					y2="766.86"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.05"
					y1="766.86"
					x2="461.34"
					y2="759.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.34"
					y1="759.54"
					x2="461.34"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="458.59"
					y1="737.21"
					x2="459.24"
					y2="737.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="459.24"
					y1="737.67"
					x2="460.21"
					y2="738.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.21"
					y1="738.98"
					x2="460.43"
					y2="740.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="460.43"
					y1="740.12"
					x2="461.05"
					y2="747.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.05"
					y1="747.42"
					x2="461.34"
					y2="754.74"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="461.34"
					y1="754.74"
					x2="461.34"
					y2="757.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.47"
					y1="738.6"
					x2="445.94"
					y2="739.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.94"
					y1="739.25"
					x2="444.82"
					y2="741.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.82"
					y1="741.28"
					x2="444.19"
					y2="743.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.19"
					y1="743.22"
					x2="443.87"
					y2="745.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="443.87 784.62 444.79 784.62 444.79 780.04 443.87 780.04 443.87 784.62"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="443.87"
					y1="780.04"
					x2="443.87"
					y2="784.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.79"
					y1="780.04"
					x2="443.87"
					y2="780.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.79"
					y1="784.62"
					x2="444.79"
					y2="780.04"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.87"
					y1="784.62"
					x2="444.79"
					y2="784.62"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="443.87 729.67 443.87 734.25 444.79 734.25 444.79 729.67 443.87 729.67"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="444.79"
					y1="729.67"
					x2="443.87"
					y2="729.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.79"
					y1="734.25"
					x2="444.79"
					y2="729.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.87"
					y1="734.25"
					x2="444.79"
					y2="734.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.87"
					y1="729.67"
					x2="443.87"
					y2="734.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="444.79 782.79 452.24 782.79 452.24 781.87 444.79 781.87 444.79 782.79"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="444.79"
					y1="781.87"
					x2="444.79"
					y2="782.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.24"
					y1="781.87"
					x2="444.79"
					y2="781.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.24"
					y1="782.79"
					x2="452.24"
					y2="781.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.79"
					y1="782.79"
					x2="452.24"
					y2="782.79"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="444.79 731.5 444.79 732.42 452.24 732.42 452.24 731.5 444.79 731.5"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="452.24"
					y1="731.5"
					x2="444.79"
					y2="731.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="452.24"
					y1="732.42"
					x2="452.24"
					y2="731.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.79"
					y1="732.42"
					x2="452.24"
					y2="732.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="444.79"
					y1="731.5"
					x2="444.79"
					y2="732.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="449.95 781.87 451.78 781.87 451.78 732.42 449.95 732.42 449.95 781.87"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="449.95"
					y1="732.42"
					x2="449.95"
					y2="781.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.78"
					y1="732.42"
					x2="449.95"
					y2="732.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.78"
					y1="781.87"
					x2="451.78"
					y2="732.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.95"
					y1="781.87"
					x2="451.78"
					y2="781.87"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="859.63 716.26 911.87 716.26 911.87 664.92 859.63 664.92 859.63 716.26"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="859.63"
					y1="664.92"
					x2="859.63"
					y2="666.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="670.26"
					x2="859.63"
					y2="675.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="679.05"
					x2="859.63"
					y2="684.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="687.84"
					x2="859.63"
					y2="693.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="696.63"
					x2="859.63"
					y2="702.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="705.42"
					x2="859.63"
					y2="710.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="714.21"
					x2="859.63"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="664.92"
					x2="909.38"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.08"
					y1="664.92"
					x2="900.59"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.29"
					y1="664.92"
					x2="891.8"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.5"
					y1="664.92"
					x2="883.01"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.71"
					y1="664.92"
					x2="874.21"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="870.92"
					y1="664.92"
					x2="865.42"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.13"
					y1="664.92"
					x2="859.63"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="716.26"
					x2="911.87"
					y2="714.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="710.92"
					x2="911.87"
					y2="705.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="702.13"
					x2="911.87"
					y2="696.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="693.33"
					x2="911.87"
					y2="687.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="684.54"
					x2="911.87"
					y2="679.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="675.76"
					x2="911.87"
					y2="670.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="666.96"
					x2="911.87"
					y2="664.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="716.26"
					x2="862.13"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.42"
					y1="716.26"
					x2="870.92"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="874.21"
					y1="716.26"
					x2="879.71"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="883.01"
					y1="716.26"
					x2="888.5"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="891.8"
					y1="716.26"
					x2="897.29"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="900.59"
					y1="716.26"
					x2="906.08"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.38"
					y1="716.26"
					x2="911.87"
					y2="716.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="856.93 665.12 855.35 665.12 855.35 716.06 856.93 716.06 856.93 708.07 855.64 708.07 855.64 673.11 856.93 673.11 856.93 665.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="856.93"
					y1="673.11"
					x2="856.93"
					y2="665.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="855.64"
					y1="673.11"
					x2="856.93"
					y2="673.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="855.64"
					y1="708.07"
					x2="855.64"
					y2="673.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="856.93"
					y1="708.07"
					x2="855.64"
					y2="708.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="856.93"
					y1="716.06"
					x2="856.93"
					y2="708.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="855.35"
					y1="716.06"
					x2="856.93"
					y2="716.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="855.35"
					y1="665.12"
					x2="855.35"
					y2="716.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="856.93"
					y1="665.12"
					x2="855.35"
					y2="665.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<polyline
					points="856.93 663.12 856.93 718.06 859.63 718.06 859.63 663.12 856.93 663.12"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="859.63"
					y1="663.12"
					x2="856.93"
					y2="663.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="859.63"
					y1="718.06"
					x2="859.63"
					y2="663.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="856.93"
					y1="718.06"
					x2="859.63"
					y2="718.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="856.93"
					y1="663.12"
					x2="856.93"
					y2="718.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".24"
				/>
				<line
					x1="856.93"
					y1="716.06"
					x2="855.35"
					y2="716.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.35"
					y1="716.06"
					x2="855.35"
					y2="665.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.35"
					y1="665.12"
					x2="856.93"
					y2="665.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="718.06"
					x2="856.93"
					y2="663.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="673.11"
					x2="855.64"
					y2="673.11"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.64"
					y1="673.11"
					x2="855.64"
					y2="708.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.64"
					y1="708.07"
					x2="856.93"
					y2="708.07"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="718.06"
					x2="856.93"
					y2="718.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="663.12"
					x2="859.63"
					y2="663.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="859.63"
					y1="663.12"
					x2="859.63"
					y2="718.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="848.48 426.15 848.48 500.61 932.69 500.61 932.69 426.15 848.48 426.15"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="932.69"
					y1="426.15"
					x2="848.48"
					y2="426.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.69"
					y1="500.61"
					x2="932.69"
					y2="426.15"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.48"
					y1="500.61"
					x2="932.69"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.48"
					y1="426.15"
					x2="848.48"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="854.2"
					y1="426.15"
					x2="854.2"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="863.51 600 863.51 657.02 864.04 658.3 865.31 658.82 903.49 658.82 904.76 658.3 905.29 657.02 905.29 600 904.76 598.72 903.49 598.19 865.31 598.19 864.04 598.72 863.51 600"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m863.51,600c0-1,.81-1.81,1.8-1.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.49"
					y1="598.19"
					x2="865.31"
					y2="598.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m903.49,598.19c.99,0,1.8.81,1.8,1.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="905.29"
					y1="657.02"
					x2="905.29"
					y2="600"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m905.29,657.02c0,.99-.81,1.8-1.8,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="865.31"
					y1="658.82"
					x2="903.49"
					y2="658.82"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m865.31,658.82c-1,0-1.8-.81-1.8-1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="863.51"
					y1="600"
					x2="863.51"
					y2="657.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.02"
					y1="604.5"
					x2="868.02"
					y2="652.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="869.82"
					y1="654.32"
					x2="894.47"
					y2="654.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="896.28"
					y1="652.51"
					x2="896.28"
					y2="604.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.47"
					y1="602.7"
					x2="869.82"
					y2="602.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="868.02"
					y1="604.5"
					x2="868.02"
					y2="604.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m869.82,654.32c-.99,0-1.8-.81-1.8-1.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m896.28,652.51c0,1-.81,1.81-1.8,1.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m894.47,602.7c1,0,1.8.81,1.8,1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m868.02,604.5c0-1,.81-1.8,1.8-1.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m889.97,628.51c0-1.49-1.21-2.7-2.7-2.7s-2.7,1.21-2.7,2.7,1.21,2.7,2.7,2.7,2.7-1.21,2.7-2.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="884.75 627.7 884.18 627.93 883.94 628.51 884.18 629.08 884.75 629.32 902.59 629.32 903.16 629.08 903.4 628.51 903.16 627.93 902.59 627.7 884.75 627.7"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="902.59"
					y1="627.7"
					x2="884.75"
					y2="627.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m902.59,627.7c.45,0,.81.36.81.81s-.36.81-.81.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.75"
					y1="629.32"
					x2="902.59"
					y2="629.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m884.75,629.32h0c-.45,0-.81-.36-.81-.81s.36-.81.81-.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="897.99 626.71 897.99 627.7 902.59 627.7 903.16 627.93 903.4 628.51 903.16 629.08 902.59 629.32 897.99 629.32 897.99 630.31 903.85 630.31 903.85 626.71 897.99 626.71"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="903.85"
					y1="626.71"
					x2="897.99"
					y2="626.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="903.85"
					y1="630.31"
					x2="903.85"
					y2="626.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.99"
					y1="630.31"
					x2="903.85"
					y2="630.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.99"
					y1="629.32"
					x2="897.99"
					y2="630.31"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="902.59"
					y1="629.32"
					x2="897.99"
					y2="629.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m902.59,627.7c.45,0,.81.36.81.81s-.36.81-.81.81"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.99"
					y1="627.7"
					x2="902.59"
					y2="627.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.99"
					y1="626.71"
					x2="897.99"
					y2="627.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="894.75 626.73 894.75 627.7 897.9 627.7 897.9 626.73 894.75 626.73"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="897.9"
					y1="626.73"
					x2="894.75"
					y2="626.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.9"
					y1="627.7"
					x2="897.9"
					y2="626.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.75"
					y1="627.7"
					x2="897.9"
					y2="627.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.75"
					y1="626.73"
					x2="894.75"
					y2="627.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="894.75 630.28 897.9 630.28 897.9 629.32 894.75 629.32 894.75 630.28"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="894.75"
					y1="629.32"
					x2="894.75"
					y2="630.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.9"
					y1="629.32"
					x2="894.75"
					y2="629.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.9"
					y1="630.28"
					x2="897.9"
					y2="629.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="894.75"
					y1="630.28"
					x2="897.9"
					y2="630.28"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="489.63 857.03 489.63 797.51 443.87 797.51 443.87 857.03 489.63 857.03"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="489.63"
					y1="857.03"
					x2="489.63"
					y2="797.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="443.87"
					y1="857.03"
					x2="443.87"
					y2="797.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.63"
					y1="797.51"
					x2="443.87"
					y2="797.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="489.63"
					y1="857.03"
					x2="443.87"
					y2="857.03"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="445.67"
					y1="857.03"
					x2="445.67"
					y2="797.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.77"
					y1="850.16"
					x2="478.77"
					y2="804.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="478.77"
					y1="804.38"
					x2="451.3"
					y2="804.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.3"
					y1="804.38"
					x2="451.3"
					y2="850.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="451.3"
					y1="850.16"
					x2="478.77"
					y2="850.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.57"
					y1="851.97"
					x2="480.57"
					y2="802.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="480.57"
					y1="802.57"
					x2="449.5"
					y2="802.57"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.5"
					y1="802.57"
					x2="449.5"
					y2="851.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.5"
					y1="851.97"
					x2="480.57"
					y2="851.97"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m460.21,827.27c0-1.49-1.21-2.7-2.7-2.7s-2.7,1.21-2.7,2.7,1.21,2.7,2.7,2.7,2.7-1.21,2.7-2.7"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="446.34 829.52 450.12 829.16 450.98 828.87 455.75 828.27 456.38 827.94 456.64 827.27 456.38 826.6 455.75 826.27 450.98 825.67 450.12 825.38 446.34 825.02 445.02 825.45 444.2 826.57 444.2 827.97 445.02 829.09 446.34 829.52"
					fill="none"
					fillRule="evenodd"
				/>
				<path
					d="m446.34,829.52c-1.25,0-2.25-1.01-2.25-2.25s1.01-2.25,2.25-2.25"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.12"
					y1="825.38"
					x2="446.34"
					y2="825.02"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m450.12,825.38c.3.03.6.13.86.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="455.75"
					y1="826.27"
					x2="450.98"
					y2="825.67"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m455.75,826.27c.5.06.88.49.88,1s-.38.94-.88,1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="450.98"
					y1="828.87"
					x2="455.75"
					y2="828.27"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m450.98,828.87c-.26.17-.55.27-.86.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="446.34"
					y1="829.52"
					x2="450.12"
					y2="829.16"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="826.05"
					x2="449.93"
					y2="826.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="449.93"
					y1="828.5"
					x2="448.59"
					y2="828.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="448.59"
					y1="828.5"
					x2="448.59"
					y2="826.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m449.93,826.05c.68,0,1.23.55,1.23,1.22s-.55,1.23-1.23,1.23"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m450.98,825.67c.54.35.87.95.87,1.6s-.33,1.25-.87,1.6"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.55"
					y1="879.64"
					x2="655.55"
					y2="864.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.55"
					y1="864.98"
					x2="695.35"
					y2="864.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.17"
					y1="879.64"
					x2="703.73"
					y2="879.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.73"
					y1="917.35"
					x2="647.17"
					y2="917.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.17"
					y1="917.35"
					x2="647.17"
					y2="860.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="703.73"
					y1="860.78"
					x2="703.73"
					y2="917.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.17"
					y1="861.83"
					x2="703.73"
					y2="861.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.35"
					y1="879.64"
					x2="695.35"
					y2="864.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="647.17"
					y1="860.78"
					x2="703.73"
					y2="860.78"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="371.41"
					y1="50"
					x2="551.35"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="551.35"
					y1="68.32"
					x2="371.41"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="687.68"
					y1="50"
					x2="840.09"
					y2="50"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="840.09"
					y1="68.32"
					x2="687.68"
					y2="68.32"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="181.61"
					x2="235.45"
					y2="390.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.14"
					y1="177.03"
					x2="217.14"
					y2="390.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="848.48"
					y1="498.12"
					x2="843.58"
					y2="498.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.58"
					y1="498.12"
					x2="843.58"
					y2="495.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="843.58"
					y1="495.64"
					x2="848.48"
					y2="495.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="426.15"
					x2="856.93"
					y2="430.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="434.26"
					x2="856.93"
					y2="439.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="443.05"
					x2="856.93"
					y2="448.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="451.84"
					x2="856.93"
					y2="457.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="460.63"
					x2="856.93"
					y2="466.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="469.42"
					x2="856.93"
					y2="474.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="478.22"
					x2="856.93"
					y2="483.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="487.01"
					x2="856.93"
					y2="492.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="495.79"
					x2="856.93"
					y2="500.61"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.93"
					y1="500.61"
					x2="856.93"
					y2="788"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="217.14"
					y1="485.95"
					x2="217.14"
					y2="637.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="235.45"
					y1="637.36"
					x2="235.45"
					y2="485.95"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.69"
					y1="382.65"
					x2="927.05"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="923.76"
					y1="382.65"
					x2="918.26"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="914.97"
					y1="382.65"
					x2="909.47"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="906.17"
					y1="382.65"
					x2="900.68"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="897.38"
					y1="382.65"
					x2="891.89"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="888.59"
					y1="382.65"
					x2="883.1"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="879.8"
					y1="382.65"
					x2="874.31"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="871.01"
					y1="382.65"
					x2="865.52"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="862.22"
					y1="382.65"
					x2="856.73"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="853.43"
					y1="382.65"
					x2="847.93"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="844.64"
					y1="382.65"
					x2="839.14"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="835.85"
					y1="382.65"
					x2="830.35"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="827.06"
					y1="382.65"
					x2="821.56"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="818.26"
					y1="382.65"
					x2="812.77"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="809.47"
					y1="382.65"
					x2="803.98"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="800.68"
					y1="382.65"
					x2="795.19"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="791.89"
					y1="382.65"
					x2="786.4"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="783.1"
					y1="382.65"
					x2="777.61"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="774.31"
					y1="382.65"
					x2="768.82"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="765.52"
					y1="382.65"
					x2="759.88"
					y2="382.65"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="932.69"
					y1="380.36"
					x2="762.17"
					y2="380.36"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="564.15"
					y1="652.19"
					x2="564.15"
					y2="493.37"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="652.19"
					x2="566.44"
					y2="650.29"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="646.99"
					x2="566.44"
					y2="641.5"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="638.21"
					x2="566.44"
					y2="632.71"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="629.42"
					x2="566.44"
					y2="623.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="620.62"
					x2="566.44"
					y2="615.13"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="611.83"
					x2="566.44"
					y2="606.34"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="603.04"
					x2="566.44"
					y2="597.55"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="594.25"
					x2="566.44"
					y2="588.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="585.46"
					x2="566.44"
					y2="579.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="576.67"
					x2="566.44"
					y2="571.18"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="567.88"
					x2="566.44"
					y2="562.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="559.09"
					x2="566.44"
					y2="553.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="550.3"
					x2="566.44"
					y2="544.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="541.51"
					x2="566.44"
					y2="536.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="532.71"
					x2="566.44"
					y2="527.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="523.92"
					x2="566.44"
					y2="518.43"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="515.13"
					x2="566.44"
					y2="509.64"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="506.34"
					x2="566.44"
					y2="500.85"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="566.44"
					y1="497.55"
					x2="566.44"
					y2="495.66"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.55"
					y1="911.06"
					x2="695.35"
					y2="911.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.35"
					y1="911.06"
					x2="695.35"
					y2="883.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="695.35"
					y1="883.83"
					x2="655.55"
					y2="883.83"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="655.55"
					y1="883.83"
					x2="655.55"
					y2="911.06"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<polyline
					points="852.35 525.22 852.35 593.9 911.87 593.9 911.87 525.22 852.35 525.22"
					fill="none"
					fillRule="evenodd"
				/>
				<line
					x1="852.35"
					y1="525.22"
					x2="852.35"
					y2="593.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="911.87"
					y1="525.22"
					x2="911.87"
					y2="593.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="910.07"
					y1="525.22"
					x2="910.07"
					y2="593.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.35"
					y1="525.22"
					x2="911.87"
					y2="525.22"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="852.35"
					y1="593.9"
					x2="911.87"
					y2="593.9"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.05"
					y1="529.73"
					x2="855.05"
					y2="589.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="855.05"
					y1="589.39"
					x2="856.86"
					y2="591.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.86"
					y1="591.2"
					x2="907.37"
					y2="591.2"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.37"
					y1="591.2"
					x2="909.17"
					y2="589.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.17"
					y1="589.39"
					x2="909.17"
					y2="529.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="909.17"
					y1="529.73"
					x2="907.37"
					y2="527.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="907.37"
					y1="527.92"
					x2="856.86"
					y2="527.92"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="856.86"
					y1="527.92"
					x2="855.05"
					y2="529.73"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m876.24,542.39c0-4.98-4.03-9.02-9.01-9.02s-9.02,4.03-9.02,9.02,4.04,9.01,9.02,9.01,9.01-4.03,9.01-9.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m903.75,542.39c0-3.73-3.03-6.76-6.76-6.76s-6.76,3.03-6.76,6.76,3.03,6.76,6.76,6.76,6.76-3.03,6.76-6.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m873.99,576.73c0-3.73-3.03-6.76-6.76-6.76s-6.76,3.03-6.76,6.76,3.03,6.76,6.76,6.76,6.76-3.03,6.76-6.76"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<path
					d="m906,576.73c0-4.98-4.03-9.02-9.01-9.02s-9.01,4.04-9.01,9.02,4.03,9.01,9.01,9.01,9.01-4.03,9.01-9.01"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="500.61"
					x2="884.4"
					y2="506.39"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="509.69"
					x2="884.4"
					y2="515.19"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="518.48"
					x2="884.4"
					y2="523.98"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="527.27"
					x2="884.4"
					y2="532.77"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="536.06"
					x2="884.4"
					y2="541.56"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="544.86"
					x2="884.4"
					y2="550.35"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="553.65"
					x2="884.4"
					y2="559.14"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="562.43"
					x2="884.4"
					y2="567.93"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="571.23"
					x2="884.4"
					y2="576.72"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="580.02"
					x2="884.4"
					y2="585.51"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="588.81"
					x2="884.4"
					y2="594.3"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="597.6"
					x2="884.4"
					y2="603.1"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="606.39"
					x2="884.4"
					y2="611.89"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="615.18"
					x2="884.4"
					y2="620.68"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="623.97"
					x2="884.4"
					y2="629.47"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="632.76"
					x2="884.4"
					y2="638.26"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="641.56"
					x2="884.4"
					y2="647.05"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="650.34"
					x2="884.4"
					y2="655.84"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="659.14"
					x2="884.4"
					y2="664.63"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="667.93"
					x2="884.4"
					y2="673.42"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="676.72"
					x2="884.4"
					y2="682.21"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="685.51"
					x2="884.4"
					y2="691"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="694.3"
					x2="884.4"
					y2="699.8"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="703.09"
					x2="884.4"
					y2="708.59"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="711.88"
					x2="884.4"
					y2="717.38"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="720.67"
					x2="884.4"
					y2="726.17"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="729.47"
					x2="884.4"
					y2="734.96"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="738.25"
					x2="884.4"
					y2="743.75"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="747.04"
					x2="884.4"
					y2="752.54"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="755.84"
					x2="884.4"
					y2="761.33"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="764.63"
					x2="884.4"
					y2="770.12"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="773.42"
					x2="884.4"
					y2="778.91"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
				<line
					x1="884.4"
					y1="782.21"
					x2="884.4"
					y2="788"
					fill="none"
					stroke="#000"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth=".5"
				/>
			</g>
			<g id="walls">
				<polygon
					points="951.01 50 951.01 806.31 875.6 806.31 875.6 948.86 850.29 948.86 850.29 930.55 857.29 930.55 857.29 788 911.87 788 911.87 500.6 932.7 500.6 932.7 426.16 744 426.16 732.56 414.7 691.31 373.45 699.39 365.36 730.05 396.02 764.73 361.57 776.39 349.98 788.32 349.98 788.32 361.57 781.24 361.57 738.28 404.24 748.74 414.7 932.7 414.7 932.7 361.74 921.66 361.74 921.66 350.29 932.7 350.29 932.7 68.31 840.08 68.31 840.08 50 951.01 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
				<polygon
					points="371.41 50 371.41 68.31 235.45 68.31 235.45 87.78 217.14 87.78 217.14 50 371.41 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
				<polygon
					points="488.14 401.18 483.27 406.06 480.06 409.27 476.84 406.06 309.53 406.06 309.53 456.05 235.45 456.05 235.45 485.95 217.14 485.95 217.14 390.37 235.45 390.37 235.45 394.62 481.59 394.62 488.14 401.18"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
				<polygon
					points="687.67 50 687.67 68.31 680.83 68.31 680.83 152.62 608.73 152.62 608.73 274.69 641.12 307.08 633.02 315.18 608.73 290.87 597.28 279.43 597.28 68.31 551.34 68.31 551.34 50 687.67 50"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
				<polygon
					points="763.29 930.55 763.29 948.86 425.56 948.86 425.56 711.66 48.99 711.66 48.99 679 217.14 679 217.14 637.37 235.45 637.37 235.45 693.35 533.55 693.35 533.55 652.18 537.18 652.18 537.18 642.38 548.63 642.38 548.63 652.18 598.48 652.18 598.48 527.71 548.63 477.85 548.63 508.45 537.18 508.45 537.18 466.4 533.91 463.13 542 455.03 598.48 511.52 609.93 522.96 609.93 725.32 598.48 725.32 598.48 715.79 443.87 715.79 443.87 860.12 464.13 860.12 464.13 930.55 598.48 930.55 598.48 812.3 609.93 812.3 609.93 844.29 644.42 844.29 644.42 855.74 639.71 855.74 639.71 930.55 710.93 930.55 710.93 855.74 706.22 855.74 706.22 844.29 722.37 844.29 722.37 930.55 763.29 930.55"
					fill="none"
					fillRule="evenodd"
					stroke="#000"
					strokeMiterlimit="10"
					strokeWidth="1.4"
				/>
			</g>
			<g id="text">
				<path d="m886.33,695.38v-10.61h3.66c.83,0,1.46.05,1.89.15.61.14,1.13.39,1.56.76.56.47.98,1.08,1.25,1.82.28.73.42,1.57.42,2.52,0,.81-.09,1.52-.28,2.14-.19.62-.43,1.14-.72,1.55-.29.41-.62.73-.97.96-.35.23-.77.41-1.27.53-.49.12-1.06.18-1.7.18h-3.83Zm1.4-1.25h2.27c.7,0,1.25-.07,1.64-.2.4-.13.72-.31.96-.55.33-.33.59-.78.77-1.34.19-.56.28-1.25.28-2.05,0-1.11-.18-1.96-.55-2.56-.36-.6-.8-1-1.32-1.2-.38-.14-.98-.22-1.82-.22h-2.23v8.11Zm11.16,1.25l-2.82-10.61h1.44l1.61,6.96c.17.73.32,1.45.45,2.17.27-1.13.43-1.79.48-1.96l2.02-7.17h1.69l1.52,5.37c.38,1.33.66,2.58.83,3.76.14-.67.31-1.44.53-2.31l1.67-6.82h1.41l-2.91,10.61h-1.35l-2.24-8.09c-.19-.68-.3-1.09-.33-1.25-.11.49-.21.9-.31,1.25l-2.25,8.09h-1.43Z" />
				<path d="m887.24,469.74h-1.49l-1.79-3c-.16-.28-.32-.51-.48-.71-.15-.2-.31-.36-.48-.48-.16-.12-.33-.21-.52-.27-.18-.06-.39-.09-.63-.09h-1.03v4.55h-1.25v-10.7h3.19c.47,0,.9.06,1.29.18.4.11.74.29,1.03.53.29.24.52.54.69.9.16.35.25.77.25,1.25,0,.37-.06.72-.17,1.03-.11.31-.27.58-.48.83-.2.24-.45.45-.75.63-.29.17-.61.3-.98.4v.03c.18.08.33.17.46.28.13.1.26.22.38.36.12.14.24.3.35.48.12.17.25.38.4.61l2.01,3.21Zm-6.42-9.56v3.88h1.7c.31,0,.6-.05.87-.14.27-.09.5-.23.69-.4.19-.18.35-.4.45-.65.11-.26.16-.55.16-.87,0-.57-.19-1.02-.56-1.34-.37-.32-.9-.48-1.6-.48h-1.72Zm13.71,6.05h-5.39c.02.85.25,1.51.69,1.97.44.46,1.04.69,1.81.69.86,0,1.65-.28,2.37-.85v1.15c-.67.49-1.56.73-2.66.73s-1.93-.35-2.54-1.04c-.62-.7-.92-1.67-.92-2.93,0-1.19.34-2.16,1.01-2.9.68-.75,1.51-1.13,2.51-1.13s1.77.32,2.32.97c.55.65.82,1.54.82,2.69v.64Zm-1.25-1.04c0-.71-.18-1.26-.51-1.65-.33-.39-.8-.59-1.39-.59s-1.07.21-1.47.62c-.4.41-.65.95-.75,1.62h4.12Zm6.74-5.68c-.24-.13-.51-.2-.81-.2-.86,0-1.28.54-1.28,1.62v1.18h1.79v1.04h-1.79v6.59h-1.22v-6.59h-1.31v-1.04h1.31v-1.24c0-.8.23-1.43.69-1.89.46-.47,1.04-.7,1.73-.7.37,0,.67.04.89.13v1.1Z" />
				<path d="m901.31,469.91c-.23,0-.43-.08-.59-.25-.16-.16-.24-.36-.24-.59s.08-.43.24-.59c.16-.17.36-.25.59-.25s.43.08.6.25c.16.16.25.36.25.59s-.08.43-.25.59c-.16.16-.36.25-.6.25Z" />
				<path d="m715.13,207.69v-16.59h4.72c1.43,0,2.57.35,3.41,1.05.84.7,1.26,1.62,1.26,2.74,0,.94-.25,1.76-.76,2.45s-1.21,1.19-2.11,1.48v.05c1.12.13,2.01.56,2.68,1.27.67.71,1.01,1.64,1.01,2.78,0,1.42-.51,2.57-1.53,3.45-1.02.88-2.3,1.32-3.85,1.32h-4.84Zm1.94-14.83v5.36h1.99c1.06,0,1.9-.25,2.51-.76.61-.52.91-1.24.91-2.18,0-1.61-1.06-2.42-3.18-2.42h-2.23Zm0,7.1v5.97h2.64c1.14,0,2.02-.27,2.65-.81.63-.54.95-1.28.95-2.22,0-1.96-1.33-2.94-4-2.94h-2.23Zm20.88,2.28h-8.37c.03,1.32.39,2.34,1.06,3.05.68.72,1.61,1.08,2.8,1.08,1.33,0,2.56-.44,3.68-1.32v1.78c-1.04.76-2.42,1.13-4.13,1.13s-2.99-.54-3.95-1.61c-.96-1.08-1.43-2.6-1.43-4.55,0-1.84.52-3.34,1.56-4.5,1.05-1.16,2.35-1.75,3.9-1.75s2.75.5,3.6,1.5c.85,1,1.27,2.4,1.27,4.18v1Zm-1.94-1.61c0-1.1-.27-1.95-.8-2.56-.52-.61-1.24-.91-2.16-.91s-1.65.32-2.28.96c-.62.64-1.01,1.48-1.16,2.51h6.4Zm14.91,7.06h-1.9v-2.01h-.05c-.88,1.53-2.24,2.29-4.07,2.29-1.49,0-2.68-.53-3.58-1.59-.89-1.06-1.33-2.51-1.33-4.34,0-1.96.49-3.53,1.48-4.71s2.3-1.77,3.95-1.77,2.81.64,3.55,1.92h.05v-7.34h1.9v17.54Zm-1.9-5.36v-1.75c0-.96-.32-1.77-.95-2.43-.63-.66-1.43-1-2.41-1-1.16,0-2.07.42-2.73,1.27s-.99,2.02-.99,3.52c0,1.37.32,2.45.95,3.24.64.79,1.5,1.18,2.57,1.18s1.91-.38,2.57-1.15c.66-.76,1-1.73,1-2.89Zm11.9-4.57c-.33-.25-.81-.38-1.43-.38-.81,0-1.49.38-2.04,1.15-.54.76-.81,1.81-.81,3.12v6.04h-1.9v-11.85h1.9v2.44h.05c.27-.83.68-1.48,1.24-1.94.56-.47,1.18-.71,1.86-.71.49,0,.87.05,1.13.16v1.97Zm7,10.21c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66s2.56-1.68,4.41-1.68,3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm13.73,10.81c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66,1.09-1.12,2.56-1.68,4.41-1.68s3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm25.6,10.53h-1.9v-6.8c0-1.31-.2-2.26-.61-2.85-.4-.59-1.08-.88-2.04-.88-.81,0-1.5.37-2.07,1.11-.56.74-.84,1.63-.84,2.66v6.76h-1.9v-7.04c0-2.33-.9-3.49-2.7-3.49-.83,0-1.52.35-2.06,1.05-.54.69-.81,1.6-.81,2.72v6.76h-1.9v-11.85h1.9v1.87h.05c.84-1.43,2.07-2.15,3.68-2.15.81,0,1.52.23,2.12.68.6.45,1.01,1.04,1.24,1.77.88-1.64,2.19-2.45,3.93-2.45,2.61,0,3.91,1.61,3.91,4.83v7.3Z" />
				<path d="m824.04,207.69h-1.9v-14.34c-.15.15-.36.32-.65.51-.28.19-.59.37-.95.56-.35.19-.72.36-1.11.52-.39.16-.76.29-1.13.38v-1.92c.42-.12.86-.27,1.32-.46.47-.2.93-.42,1.38-.66.46-.25.88-.5,1.28-.76.4-.27.75-.53,1.04-.79h.72v16.96Z" />
				<path d="m724.86,232.29h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm9.31,0h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Z" />
				<rect x="738.76" y="220.22" width="1.22" height="3.76" />
				<path d="m747.39,232.29h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm11.8-6.09c0,1.01-.09,1.91-.28,2.69-.18.78-.44,1.44-.79,1.98-.34.53-.77.94-1.27,1.22-.5.27-1.07.41-1.71.41-.61,0-1.15-.13-1.62-.4-.47-.27-.87-.66-1.2-1.17-.33-.51-.57-1.14-.74-1.88-.17-.75-.25-1.6-.25-2.56,0-1.05.09-1.99.26-2.79.18-.81.44-1.48.78-2.03.34-.55.77-.96,1.27-1.24.51-.28,1.09-.42,1.75-.42,2.53,0,3.8,2.06,3.8,6.19Zm-1.41.13c0-3.43-.82-5.15-2.45-5.15-1.72,0-2.58,1.75-2.58,5.24,0,3.26.84,4.89,2.53,4.89s2.5-1.66,2.5-4.98Z" />
				<path d="m762.5,220.22v3.76h-1.22v-3.76h1.22Zm2.79,0v3.76h-1.22v-3.76h1.22Z" />
				<path d="m779.09,223.67l-2.9,4.36,2.84,4.26h-1.61l-1.69-2.79c-.11-.17-.23-.39-.38-.66h-.03c-.03.05-.16.27-.4.66l-1.73,2.79h-1.59l2.94-4.23-2.81-4.39h1.61l1.67,2.95c.12.22.24.44.36.67h.03l2.15-3.62h1.52Z" />
				<path d="m790.13,232.29h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm11.8-6.09c0,1.01-.09,1.91-.28,2.69-.18.78-.44,1.44-.79,1.98-.34.53-.77.94-1.27,1.22-.5.27-1.07.41-1.71.41-.61,0-1.15-.13-1.62-.4-.47-.27-.87-.66-1.2-1.17-.33-.51-.57-1.14-.74-1.88-.17-.75-.25-1.6-.25-2.56,0-1.05.09-1.99.26-2.79.18-.81.44-1.48.78-2.03.34-.55.77-.96,1.27-1.24.51-.28,1.09-.42,1.75-.42,2.53,0,3.8,2.06,3.8,6.19Zm-1.41.13c0-3.43-.82-5.15-2.45-5.15-1.72,0-2.58,1.75-2.58,5.24,0,3.26.84,4.89,2.53,4.89s2.5-1.66,2.5-4.98Z" />
				<rect x="804.03" y="220.22" width="1.22" height="3.76" />
				<path d="m813.72,220.22v7.97h1.55v1.26h-1.55v2.84h-1.36v-2.84h-5.67v-1.2c.53-.59,1.06-1.23,1.6-1.9.54-.68,1.05-1.37,1.54-2.06.49-.7.95-1.39,1.36-2.08.42-.7.77-1.36,1.06-1.99h1.47Zm-5.48,7.97h4.12v-5.91c-.42.74-.82,1.39-1.2,1.97-.38.58-.74,1.1-1.08,1.57-.34.47-.66.9-.97,1.28-.31.38-.6.74-.88,1.09Z" />
				<path d="m818.46,220.22v3.76h-1.22v-3.76h1.22Zm2.79,0v3.76h-1.22v-3.76h1.22Z" />
				<path d="m328.92,546.5v-16.59h4.72c1.43,0,2.57.35,3.41,1.05.84.7,1.26,1.62,1.26,2.74,0,.94-.25,1.76-.76,2.45-.51.69-1.21,1.19-2.11,1.48v.05c1.12.13,2.01.56,2.68,1.27.67.71,1.01,1.64,1.01,2.78,0,1.42-.51,2.57-1.53,3.45-1.02.88-2.3,1.32-3.85,1.32h-4.84Zm1.94-14.83v5.36h1.99c1.06,0,1.9-.25,2.51-.76.61-.52.91-1.24.91-2.18,0-1.61-1.06-2.42-3.18-2.42h-2.23Zm0,7.1v5.97h2.64c1.14,0,2.02-.27,2.65-.81.63-.54.95-1.28.95-2.22,0-1.96-1.33-2.94-4-2.94h-2.23Zm20.88,2.28h-8.37c.03,1.32.39,2.34,1.06,3.05.68.72,1.61,1.08,2.8,1.08,1.33,0,2.56-.44,3.68-1.32v1.78c-1.04.76-2.42,1.13-4.13,1.13s-2.99-.54-3.95-1.61c-.96-1.08-1.43-2.6-1.43-4.55,0-1.84.52-3.34,1.56-4.5,1.05-1.16,2.35-1.75,3.9-1.75s2.75.5,3.6,1.5,1.27,2.4,1.27,4.18v1Zm-1.94-1.61c0-1.1-.27-1.95-.8-2.56-.52-.61-1.24-.91-2.16-.91s-1.65.32-2.28.96c-.62.64-1.01,1.48-1.16,2.51h6.4Zm14.91,7.06h-1.9v-2.01h-.05c-.88,1.53-2.24,2.29-4.07,2.29-1.49,0-2.68-.53-3.58-1.59-.89-1.06-1.33-2.51-1.33-4.34,0-1.96.49-3.53,1.48-4.71.99-1.18,2.3-1.77,3.95-1.77s2.81.64,3.55,1.92h.05v-7.34h1.9v17.54Zm-1.9-5.36v-1.75c0-.96-.32-1.77-.95-2.43-.63-.66-1.43-1-2.41-1-1.16,0-2.07.42-2.73,1.27-.66.85-1,2.02-1,3.52,0,1.37.32,2.45.95,3.24.64.79,1.5,1.18,2.57,1.18s1.91-.38,2.57-1.15c.66-.76,1-1.73,1-2.89Zm11.9-4.57c-.33-.25-.81-.38-1.43-.38-.81,0-1.49.38-2.04,1.15-.54.76-.81,1.81-.81,3.12v6.04h-1.9v-11.85h1.9v2.44h.05c.27-.83.68-1.48,1.24-1.94.56-.47,1.18-.71,1.86-.71.49,0,.87.05,1.13.16v1.97Zm7,10.21c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66s2.56-1.68,4.41-1.68,3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm13.73,10.81c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66,1.09-1.12,2.56-1.68,4.41-1.68s3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm25.6,10.53h-1.9v-6.8c0-1.31-.2-2.26-.61-2.85-.4-.59-1.08-.88-2.04-.88-.81,0-1.5.37-2.07,1.11-.56.74-.84,1.63-.84,2.66v6.76h-1.9v-7.04c0-2.33-.9-3.49-2.7-3.49-.83,0-1.52.35-2.06,1.05-.54.69-.81,1.6-.81,2.72v6.76h-1.9v-11.85h1.9v1.87h.05c.84-1.43,2.07-2.15,3.68-2.15.81,0,1.52.23,2.12.68.6.45,1.01,1.04,1.24,1.77.88-1.64,2.19-2.45,3.93-2.45,2.61,0,3.91,1.61,3.91,4.83v7.3Z" />
				<path d="m438.39,534.25c0-.51-.08-.95-.24-1.33-.15-.38-.37-.69-.65-.94-.27-.25-.59-.44-.96-.57-.37-.12-.77-.19-1.2-.19-.37,0-.73.05-1.09.15-.35.1-.7.24-1.04.42-.33.18-.66.39-.97.64-.31.25-.6.52-.87.82v-2.04c.53-.52,1.13-.91,1.78-1.18.66-.28,1.47-.42,2.42-.42.68,0,1.31.1,1.89.3.58.19,1.08.48,1.5.86.42.38.76.84,1,1.4.25.56.37,1.19.37,1.91,0,.66-.08,1.25-.23,1.78-.15.53-.37,1.03-.68,1.5-.3.47-.68.92-1.15,1.35-.46.43-1.01.87-1.63,1.32-.78.56-1.42,1.03-1.93,1.42-.5.39-.9.76-1.2,1.11-.29.34-.5.68-.62,1.03-.12.34-.17.73-.17,1.18h8.26v1.7h-10.24v-.82c0-.71.08-1.33.23-1.87.15-.54.41-1.05.76-1.54.35-.49.82-.97,1.39-1.46.58-.49,1.28-1.03,2.12-1.64.6-.43,1.1-.84,1.5-1.24.41-.39.74-.79.98-1.18.25-.39.42-.79.52-1.19.11-.41.16-.84.16-1.3Z" />
				<path d="m343.31,571.1h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm9.31,0h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Z" />
				<rect x="357.2" y="559.03" width="1.22" height="3.76" />
				<path d="m368.32,565.01c0,1.01-.09,1.91-.28,2.69-.18.78-.44,1.44-.79,1.98-.34.53-.77.94-1.27,1.22-.5.27-1.07.41-1.71.41-.61,0-1.15-.13-1.62-.4-.47-.27-.87-.66-1.2-1.17s-.57-1.14-.74-1.88c-.17-.75-.25-1.6-.25-2.56,0-1.05.09-1.99.26-2.79.18-.81.44-1.48.78-2.03.34-.55.77-.96,1.27-1.24.51-.28,1.09-.42,1.75-.42,2.53,0,3.8,2.06,3.8,6.19Zm-1.41.13c0-3.43-.82-5.15-2.45-5.15-1.72,0-2.58,1.75-2.58,5.24,0,3.26.84,4.89,2.53,4.89s2.5-1.66,2.5-4.98Z" />
				<path d="m371.64,559.03v3.76h-1.22v-3.76h1.22Zm2.79,0v3.76h-1.22v-3.76h1.22Z" />
				<path d="m388.23,562.48l-2.9,4.36,2.84,4.26h-1.61l-1.69-2.79c-.11-.17-.23-.39-.38-.66h-.03c-.03.05-.16.27-.4.66l-1.73,2.79h-1.59l2.94-4.23-2.81-4.39h1.61l1.67,2.95c.12.22.24.44.36.67h.03l2.15-3.62h1.52Z" />
				<path d="m399.27,571.1h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm11.8-6.09c0,1.01-.09,1.91-.28,2.69-.18.78-.44,1.44-.79,1.98-.34.53-.77.94-1.27,1.22-.5.27-1.07.41-1.71.41-.61,0-1.15-.13-1.62-.4-.47-.27-.87-.66-1.2-1.17-.33-.51-.57-1.14-.74-1.88-.17-.75-.25-1.6-.25-2.56,0-1.05.09-1.99.26-2.79.18-.81.44-1.48.78-2.03.34-.55.77-.96,1.27-1.24.51-.28,1.09-.42,1.75-.42,2.53,0,3.8,2.06,3.8,6.19Zm-1.41.13c0-3.43-.82-5.15-2.45-5.15-1.72,0-2.58,1.75-2.58,5.24,0,3.26.84,4.89,2.53,4.89s2.5-1.66,2.5-4.98Z" />
				<rect x="413.16" y="559.03" width="1.22" height="3.76" />
				<path d="m424.3,567.27c0,.59-.1,1.13-.29,1.62-.19.49-.45.92-.79,1.28-.34.36-.74.64-1.2.84-.47.2-.97.29-1.52.29-.61,0-1.15-.13-1.63-.38-.48-.25-.88-.61-1.22-1.09-.33-.48-.58-1.06-.76-1.74-.17-.68-.26-1.46-.26-2.31,0-1.05.11-2,.35-2.85.24-.86.57-1.59.99-2.2.43-.61.95-1.08,1.56-1.41.61-.33,1.28-.5,2.03-.5.83,0,1.5.12,2,.35v1.3c-.62-.32-1.28-.48-1.97-.48-.54,0-1.02.12-1.46.36-.43.24-.8.58-1.11,1.03-.31.44-.55.97-.72,1.59-.16.62-.24,1.32-.24,2.08h.03c.56-1,1.47-1.51,2.75-1.51.53,0,1,.09,1.42.27.43.18.79.43,1.09.77.3.33.54.72.7,1.17.16.45.24.96.24,1.52Zm-1.41.18c0-.42-.05-.8-.16-1.14-.11-.34-.26-.62-.46-.86-.2-.24-.44-.42-.73-.54-.29-.13-.62-.19-.99-.19-.34,0-.66.06-.95.19-.29.13-.54.31-.76.53-.21.22-.38.48-.51.77-.12.29-.18.6-.18.93,0,.42.06.81.18,1.17.12.36.28.67.5.94.21.27.47.48.76.64.3.15.63.23.98.23s.66-.06.95-.19c.29-.13.53-.32.73-.56.2-.24.36-.52.47-.84.11-.33.17-.7.17-1.09Z" />
				<path d="m427.6,559.03v3.76h-1.22v-3.76h1.22Zm2.79,0v3.76h-1.22v-3.76h1.22Z" />
				<path d="m522.69,838.69v-16.59h4.72c1.43,0,2.57.35,3.41,1.05.84.7,1.26,1.62,1.26,2.74,0,.94-.25,1.76-.76,2.45-.51.69-1.21,1.19-2.11,1.48v.05c1.12.13,2.01.56,2.68,1.27.67.71,1.01,1.64,1.01,2.78,0,1.42-.51,2.57-1.53,3.45-1.02.88-2.3,1.32-3.85,1.32h-4.84Zm1.94-14.83v5.36h1.99c1.06,0,1.9-.25,2.51-.76.61-.52.91-1.24.91-2.18,0-1.61-1.06-2.42-3.18-2.42h-2.23Zm0,7.1v5.97h2.64c1.14,0,2.02-.27,2.65-.81.63-.54.95-1.28.95-2.22,0-1.96-1.33-2.94-4-2.94h-2.23Zm19.86,7.73h-1.9v-1.85h-.05c-.83,1.42-2.04,2.13-3.64,2.13-1.18,0-2.11-.31-2.78-.94-.66-.62-1-1.45-1-2.49,0-2.21,1.3-3.5,3.91-3.86l3.55-.5c0-2.01-.81-3.02-2.44-3.02-1.43,0-2.72.49-3.86,1.46v-1.94c1.16-.74,2.51-1.11,4.03-1.11,2.78,0,4.18,1.47,4.18,4.42v7.71Zm-1.9-5.99l-2.86.39c-.88.12-1.54.34-1.99.66-.45.31-.67.86-.67,1.65,0,.58.2,1.05.61,1.42.42.36.97.54,1.65.54.94,0,1.72-.33,2.33-.98.62-.66.93-1.5.93-2.51v-1.18Zm10.97,5.88c-.45.25-1.04.37-1.77.37-2.08,0-3.11-1.16-3.11-3.47v-7.01h-2.04v-1.62h2.04v-2.89l1.9-.61v3.51h2.99v1.62h-2.99v6.68c0,.79.13,1.36.4,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.24-.39v1.62Zm12.37.12h-1.9v-6.83c0-2.47-.92-3.7-2.75-3.7-.93,0-1.7.36-2.34,1.08-.63.71-.95,1.62-.95,2.74v6.71h-1.9v-17.54h1.9v7.66h.05c.91-1.5,2.21-2.24,3.89-2.24,2.67,0,4,1.61,4,4.83v7.3Z" />
				<path d="m66.01,389.63v6.27h-1.94v-16.59h4.56c1.77,0,3.15.43,4.12,1.3.98.86,1.47,2.08,1.47,3.66s-.54,2.86-1.63,3.86c-1.08,1-2.54,1.5-4.39,1.5h-2.19Zm0-8.56v6.8h2.04c1.34,0,2.36-.3,3.07-.91.71-.62,1.06-1.48,1.06-2.6,0-2.19-1.3-3.29-3.89-3.29h-2.28Zm19.38,14.83h-1.9v-1.85h-.05c-.83,1.42-2.04,2.13-3.64,2.13-1.18,0-2.11-.31-2.78-.94-.66-.62-1-1.45-1-2.49,0-2.21,1.3-3.5,3.91-3.86l3.55-.5c0-2.01-.81-3.02-2.44-3.02-1.43,0-2.72.49-3.86,1.46v-1.94c1.16-.74,2.51-1.11,4.03-1.11,2.78,0,4.18,1.47,4.18,4.42v7.71Zm-1.9-5.99l-2.86.39c-.88.12-1.54.34-1.99.66-.45.31-.67.86-.67,1.65,0,.58.2,1.05.61,1.42.42.36.97.54,1.65.54.94,0,1.72-.33,2.33-.98.62-.66.93-1.5.93-2.51v-1.18Zm10.81,5.88c-.45.25-1.04.37-1.77.37-2.08,0-3.11-1.16-3.11-3.47v-7.01h-2.04v-1.62h2.04v-2.89l1.9-.61v3.51h2.99v1.62h-2.99v6.68c0,.79.14,1.36.4,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.24-.39v1.62Zm3.34-14.74c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.93,14.86h-1.9v-11.85h1.9v11.85Zm8.62.28c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66,1.09-1.12,2.56-1.68,4.41-1.68s3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Z" />
				<polygon points="123.44 379.31 115.48 398.66 113.7 398.66 121.64 379.31 123.44 379.31" />
				<path d="m125.37,395.9v-16.59h4.72c1.43,0,2.57.35,3.41,1.05.84.7,1.26,1.62,1.26,2.74,0,.94-.25,1.76-.76,2.45-.51.69-1.21,1.19-2.11,1.48v.05c1.12.13,2.01.56,2.68,1.27.67.71,1.01,1.64,1.01,2.78,0,1.42-.51,2.57-1.53,3.45s-2.3,1.32-3.85,1.32h-4.84Zm1.94-14.83v5.36h1.99c1.06,0,1.9-.25,2.51-.76.61-.52.91-1.24.91-2.18,0-1.61-1.06-2.42-3.18-2.42h-2.23Zm0,7.1v5.97h2.64c1.14,0,2.02-.27,2.65-.81.63-.54.95-1.28.95-2.22,0-1.96-1.33-2.94-4-2.94h-2.23Zm19.86,7.73h-1.9v-1.85h-.05c-.83,1.42-2.04,2.13-3.64,2.13-1.18,0-2.11-.31-2.78-.94-.66-.62-1-1.45-1-2.49,0-2.21,1.3-3.5,3.91-3.86l3.55-.5c0-2.01-.81-3.02-2.44-3.02-1.43,0-2.72.49-3.86,1.46v-1.94c1.16-.74,2.51-1.11,4.03-1.11,2.78,0,4.18,1.47,4.18,4.42v7.71Zm-1.9-5.99l-2.86.39c-.88.12-1.54.34-1.99.66-.45.31-.67.86-.67,1.65,0,.58.2,1.05.61,1.42.42.36.97.54,1.65.54.94,0,1.72-.33,2.33-.98.62-.66.93-1.5.93-2.51v-1.18Zm7.37,5.99h-1.9v-17.54h1.9v17.54Zm11.91-.54c-.91.55-1.99.82-3.24.82-1.69,0-3.05-.55-4.1-1.64-1.03-1.1-1.55-2.53-1.55-4.28,0-1.95.56-3.52,1.68-4.7,1.12-1.19,2.61-1.78,4.48-1.78,1.04,0,1.96.19,2.75.58v1.94c-.88-.62-1.82-.93-2.82-.93-1.21,0-2.21.44-2.99,1.31-.77.86-1.16,2-1.16,3.41s.36,2.48,1.09,3.29c.73.8,1.71,1.2,2.94,1.2,1.03,0,2.01-.34,2.92-1.03v1.81Zm7.82.82c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66,1.09-1.12,2.56-1.68,4.41-1.68s3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm18.63,10.53h-1.9v-6.76c0-2.51-.92-3.77-2.75-3.77-.95,0-1.74.36-2.36,1.08-.62.71-.93,1.61-.93,2.7v6.76h-1.9v-11.85h1.9v1.97h.05c.89-1.5,2.19-2.24,3.89-2.24,1.3,0,2.29.42,2.97,1.26.69.83,1.03,2.04,1.03,3.62v7.24Zm13-11.85l-5.45,13.75c-.97,2.45-2.34,3.68-4.1,3.68-.49,0-.91-.05-1.24-.15v-1.7c.41.14.78.21,1.12.21.96,0,1.67-.57,2.15-1.71l.95-2.24-4.63-11.83h2.11l3.21,9.12c.04.12.12.42.24.9h.07c.04-.19.12-.48.23-.88l3.37-9.14h1.97Z" />
				<path d="m774.17,862.53h-8.79v-16.59h8.42v1.76h-6.48v5.52h5.99v1.75h-5.99v5.81h6.85v1.76Zm12.8,0h-1.9v-6.76c0-2.51-.92-3.77-2.75-3.77-.95,0-1.74.36-2.36,1.08-.62.71-.93,1.61-.93,2.7v6.76h-1.9v-11.85h1.9v1.97h.05c.89-1.5,2.19-2.24,3.89-2.24,1.3,0,2.29.42,2.97,1.26.69.83,1.03,2.04,1.03,3.62v7.24Zm9.09-.12c-.45.25-1.04.37-1.77.37-2.08,0-3.11-1.16-3.11-3.47v-7.01h-2.04v-1.62h2.04v-2.89l1.9-.61v3.51h2.99v1.62h-2.99v6.68c0,.79.14,1.36.41,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.24-.39v1.62Zm8.73-9.81c-.33-.25-.81-.38-1.43-.38-.81,0-1.49.38-2.04,1.15-.54.76-.81,1.81-.81,3.12v6.04h-1.9v-11.85h1.9v2.44h.05c.27-.83.68-1.48,1.24-1.94.56-.47,1.18-.71,1.86-.71.49,0,.87.05,1.13.16v1.97Zm11.52-1.92l-5.45,13.75c-.97,2.45-2.34,3.68-4.1,3.68-.49,0-.91-.05-1.24-.15v-1.7c.41.14.78.21,1.12.21.96,0,1.67-.57,2.15-1.71l.95-2.24-4.63-11.83h2.11l3.21,9.12c.04.12.12.42.24.9h.07c.04-.19.12-.48.23-.88l3.37-9.14h1.97Z" />
				<path d="m775.58,616.95h-2.71l-6.41-7.59c-.24-.29-.39-.48-.44-.58h-.05v8.17h-1.94v-16.59h1.94v7.8h.05c.11-.17.25-.36.44-.57l6.2-7.23h2.42l-7.12,7.96,7.61,8.63Zm2.9-14.86c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.93,14.86h-1.9v-11.85h1.9v11.85Zm9.32-.12c-.45.25-1.04.37-1.77.37-2.08,0-3.11-1.16-3.11-3.47v-7.01h-2.04v-1.62h2.04v-2.89l1.9-.61v3.51h2.99v1.62h-2.99v6.68c0,.79.13,1.36.4,1.7.27.34.72.51,1.34.51.48,0,.89-.13,1.24-.39v1.62Zm10.6-.43c-.91.55-1.99.82-3.24.82-1.69,0-3.05-.55-4.1-1.64-1.03-1.1-1.55-2.53-1.55-4.28,0-1.95.56-3.52,1.68-4.7,1.12-1.19,2.61-1.78,4.48-1.78,1.04,0,1.96.19,2.75.58v1.94c-.88-.62-1.82-.93-2.82-.93-1.21,0-2.21.44-2.99,1.31-.77.86-1.16,2-1.16,3.41s.36,2.48,1.09,3.29c.73.8,1.71,1.2,2.94,1.2,1.03,0,2.01-.34,2.92-1.03v1.81Zm12.69.54h-1.9v-6.83c0-2.47-.92-3.7-2.75-3.7-.93,0-1.7.36-2.34,1.08-.63.71-.95,1.62-.95,2.74v6.71h-1.9v-17.54h1.9v7.66h.05c.91-1.5,2.21-2.24,3.89-2.24,2.67,0,4,1.61,4,4.83v7.3Zm13.09-5.45h-8.37c.03,1.32.39,2.34,1.06,3.05.68.72,1.61,1.08,2.8,1.08,1.33,0,2.56-.44,3.68-1.32v1.78c-1.04.76-2.42,1.13-4.13,1.13s-2.99-.54-3.95-1.61c-.96-1.08-1.43-2.6-1.43-4.55,0-1.84.52-3.34,1.56-4.5,1.05-1.16,2.35-1.75,3.9-1.75s2.75.5,3.6,1.5c.85,1,1.27,2.4,1.27,4.18v1Zm-1.94-1.61c0-1.1-.27-1.95-.8-2.56-.52-.61-1.24-.91-2.16-.91s-1.65.32-2.28.96c-.62.64-1.01,1.48-1.16,2.51h6.4Zm14.64,7.06h-1.9v-6.76c0-2.51-.92-3.77-2.75-3.77-.95,0-1.74.36-2.36,1.08-.62.71-.93,1.61-.93,2.7v6.76h-1.9v-11.85h1.9v1.97h.05c.89-1.5,2.19-2.24,3.89-2.24,1.3,0,2.29.42,2.97,1.26.69.83,1.03,2.04,1.03,3.62v7.24Z" />
				<path d="m323.42,227.73h-8.61v-16.59h1.94v14.83h6.66v1.76Zm3.26-14.86c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.93,14.86h-1.9v-11.85h1.9v11.85Zm13.14-11.85l-4.72,11.85h-1.86l-4.49-11.85h2.08l3.01,8.61c.22.63.36,1.18.42,1.65h.05c.08-.59.2-1.13.37-1.61l3.15-8.66h2Zm3-3.01c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.93,14.86h-1.9v-11.85h1.9v11.85Zm13.66,0h-1.9v-6.76c0-2.51-.92-3.77-2.75-3.77-.95,0-1.74.36-2.36,1.08-.62.71-.93,1.61-.93,2.7v6.76h-1.9v-11.85h1.9v1.97h.05c.89-1.5,2.19-2.24,3.89-2.24,1.3,0,2.29.42,2.97,1.26.69.83,1.03,2.04,1.03,3.62v7.24Zm13.68-.95c0,4.35-2.08,6.53-6.25,6.53-1.47,0-2.75-.28-3.84-.83v-1.9c1.33.74,2.61,1.11,3.82,1.11,2.92,0,4.37-1.55,4.37-4.65v-1.3h-.05c-.9,1.51-2.26,2.27-4.07,2.27-1.47,0-2.66-.52-3.56-1.57-.89-1.06-1.34-2.47-1.34-4.25,0-2.01.48-3.61,1.45-4.8.97-1.19,2.3-1.78,3.98-1.78s2.78.64,3.55,1.92h.05v-1.64h1.9v10.9Zm-1.9-4.41v-1.75c0-.94-.32-1.75-.96-2.42-.63-.67-1.42-1.01-2.37-1.01-1.17,0-2.09.43-2.75,1.28-.66.85-1,2.04-1,3.58,0,1.32.32,2.38.95,3.17.64.79,1.48,1.18,2.53,1.18s1.93-.38,2.59-1.13c.67-.76,1.01-1.72,1.01-2.9Z" />
				<polygon points="383.35 211.14 375.39 230.49 373.62 230.49 381.56 211.14 383.35 211.14" />
				<path d="m385.28,227.73v-16.59h4.58c5.85,0,8.77,2.7,8.77,8.09,0,2.56-.81,4.62-2.44,6.18-1.62,1.55-3.79,2.33-6.51,2.33h-4.4Zm1.94-14.83v13.08h2.48c2.18,0,3.87-.58,5.08-1.75,1.21-1.16,1.82-2.82,1.82-4.95,0-4.25-2.26-6.38-6.78-6.38h-2.59Zm15.32-.02c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.93,14.86h-1.9v-11.85h1.9v11.85Zm13.6,0h-1.9v-6.76c0-2.51-.92-3.77-2.75-3.77-.95,0-1.74.36-2.36,1.08-.62.71-.93,1.61-.93,2.7v6.76h-1.9v-11.85h1.9v1.97h.05c.89-1.5,2.19-2.24,3.89-2.24,1.3,0,2.29.42,2.97,1.26.69.83,1.03,2.04,1.03,3.62v7.24Zm4.48-14.86c-.34,0-.63-.12-.87-.35-.24-.23-.36-.52-.36-.88s.12-.65.36-.88c.24-.24.53-.36.87-.36s.64.12.88.36c.25.23.37.52.37.88s-.12.63-.37.87c-.24.24-.53.36-.88.36Zm.93,14.86h-1.9v-11.85h1.9v11.85Zm13.6,0h-1.9v-6.76c0-2.51-.92-3.77-2.75-3.77-.95,0-1.74.36-2.36,1.08-.62.71-.93,1.61-.93,2.7v6.76h-1.9v-11.85h1.9v1.97h.05c.89-1.5,2.19-2.24,3.89-2.24,1.3,0,2.29.42,2.97,1.26.69.83,1.03,2.04,1.03,3.62v7.24Zm13.62-.95c0,4.35-2.08,6.53-6.25,6.53-1.47,0-2.75-.28-3.84-.83v-1.9c1.33.74,2.61,1.11,3.82,1.11,2.92,0,4.37-1.55,4.37-4.65v-1.3h-.05c-.9,1.51-2.26,2.27-4.07,2.27-1.47,0-2.66-.52-3.56-1.57-.89-1.06-1.34-2.47-1.34-4.25,0-2.01.48-3.61,1.45-4.8.97-1.19,2.3-1.78,3.98-1.78s2.78.64,3.55,1.92h.05v-1.64h1.9v10.9Zm-1.9-4.41v-1.75c0-.94-.32-1.75-.96-2.42-.63-.67-1.42-1.01-2.37-1.01-1.17,0-2.09.43-2.75,1.28-.66.85-1,2.04-1,3.58,0,1.32.32,2.38.95,3.17.64.79,1.48,1.18,2.53,1.18s1.93-.38,2.59-1.13c.67-.76,1.01-1.72,1.01-2.9Z" />
				<path d="m472.39,227.73h-2.31l-2.78-4.65c-.25-.43-.5-.8-.74-1.1-.24-.31-.49-.56-.74-.75-.25-.19-.52-.33-.81-.42-.29-.09-.61-.14-.97-.14h-1.6v7.06h-1.94v-16.59h4.95c.73,0,1.39.09,2,.28.62.18,1.15.45,1.6.82.46.37.81.83,1.06,1.39.25.55.38,1.19.38,1.93,0,.58-.09,1.11-.27,1.6-.17.48-.42.91-.74,1.28-.32.38-.7.7-1.16.97-.45.26-.95.47-1.52.61v.05c.28.12.52.27.72.43.21.15.4.34.59.56s.37.46.54.74c.19.27.39.59.61.95l3.11,4.99Zm-9.95-14.83v6.02h2.64c.49,0,.93-.07,1.34-.22.42-.15.78-.35,1.08-.62.3-.28.54-.61.71-1.01.17-.4.25-.85.25-1.34,0-.89-.29-1.58-.87-2.07-.57-.5-1.4-.75-2.49-.75h-2.66Zm16.86,15.11c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66,1.09-1.12,2.56-1.68,4.41-1.68s3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm13.68,10.81c-1.75,0-3.15-.55-4.2-1.65-1.04-1.11-1.56-2.58-1.56-4.41,0-1.99.54-3.54,1.63-4.66,1.09-1.12,2.56-1.68,4.41-1.68s3.14.54,4.13,1.63c1,1.09,1.49,2.6,1.49,4.52s-.54,3.41-1.61,4.55c-1.06,1.13-2.5,1.7-4.29,1.7Zm.14-10.81c-1.22,0-2.18.42-2.89,1.25-.71.83-1.06,1.97-1.06,3.43s.36,2.51,1.08,3.32c.72.81,1.68,1.21,2.88,1.21s2.17-.4,2.82-1.19c.66-.79,1-1.92,1-3.39s-.33-2.62-1-3.43c-.66-.8-1.6-1.2-2.82-1.2Zm25.55,10.53h-1.9v-6.8c0-1.31-.2-2.26-.61-2.85-.4-.59-1.08-.88-2.04-.88-.81,0-1.5.37-2.07,1.11-.56.74-.84,1.63-.84,2.66v6.76h-1.9v-7.04c0-2.33-.9-3.49-2.7-3.49-.83,0-1.52.35-2.06,1.05-.54.69-.81,1.6-.81,2.72v6.76h-1.9v-11.85h1.9v1.87h.05c.84-1.43,2.07-2.15,3.68-2.15.81,0,1.52.23,2.12.68.6.45,1.01,1.04,1.24,1.77.88-1.64,2.19-2.45,3.93-2.45,2.61,0,3.91,1.61,3.91,4.83v7.3Z" />
				<path d="m370.52,252.33h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm11.24-3.42c0,.54-.1,1.04-.31,1.49-.2.44-.49.82-.87,1.14-.37.31-.82.56-1.34.73-.52.17-1.1.26-1.73.26-1.15,0-2.06-.22-2.74-.66v-1.48c.81.64,1.75.96,2.79.96.42,0,.8-.05,1.14-.16.34-.11.63-.26.88-.46.25-.2.43-.45.56-.73.13-.29.2-.61.2-.97,0-1.58-1.12-2.37-3.37-2.37h-1v-1.17h.95c1.99,0,2.98-.74,2.98-2.22,0-1.37-.76-2.05-2.27-2.05-.85,0-1.65.29-2.4.86v-1.34c.77-.46,1.68-.69,2.74-.69.51,0,.96.07,1.37.21.41.14.76.34,1.05.59.29.25.52.56.67.91.16.35.24.74.24,1.17,0,1.59-.8,2.61-2.41,3.06v.03c.41.04.79.15,1.14.3.35.15.65.35.9.6.25.25.45.54.59.88.15.33.22.7.22,1.1Z" />
				<rect x="384.41" y="240.26" width="1.22" height="3.76" />
				<path d="m394.97,248.91c0,.54-.1,1.04-.31,1.49-.2.44-.49.82-.87,1.14-.37.31-.82.56-1.34.73-.52.17-1.1.26-1.73.26-1.15,0-2.06-.22-2.74-.66v-1.48c.81.64,1.75.96,2.79.96.42,0,.8-.05,1.14-.16.34-.11.63-.26.88-.46.25-.2.43-.45.56-.73.13-.29.2-.61.2-.97,0-1.58-1.12-2.37-3.37-2.37h-1v-1.17h.95c1.99,0,2.98-.74,2.98-2.22,0-1.37-.76-2.05-2.27-2.05-.85,0-1.65.29-2.4.86v-1.34c.77-.46,1.68-.69,2.74-.69.51,0,.96.07,1.37.21.41.14.76.34,1.05.59.29.25.52.56.67.91.16.35.24.74.24,1.17,0,1.59-.8,2.61-2.41,3.06v.03c.41.04.79.15,1.14.3.35.15.65.35.9.6.25.25.45.54.59.88.15.33.22.7.22,1.1Z" />
				<path d="m398.85,240.26v3.76h-1.22v-3.76h1.22Zm2.79,0v3.76h-1.22v-3.76h1.22Z" />
				<path d="m415.44,243.71l-2.9,4.36,2.84,4.26h-1.61l-1.69-2.79c-.11-.17-.23-.39-.38-.66h-.03c-.03.05-.16.27-.4.66l-1.73,2.79h-1.59l2.94-4.23-2.81-4.39h1.61l1.67,2.95c.12.22.24.44.36.67h.03l2.15-3.62h1.52Z" />
				<path d="m426.48,252.33h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm9.31,0h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Z" />
				<rect x="440.38" y="240.26" width="1.22" height="3.76" />
				<path d="m449.01,252.33h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Zm9.31,0h-1.38v-10.43c-.11.11-.26.23-.47.37-.2.13-.43.27-.69.4-.25.13-.52.26-.81.38-.28.12-.56.21-.82.28v-1.4c.3-.08.62-.2.96-.34.34-.15.68-.31,1-.48.33-.18.64-.36.93-.56.29-.2.54-.39.76-.57h.52v12.34Z" />
				<path d="m464.12,240.26v3.76h-1.22v-3.76h1.22Zm2.79,0v3.76h-1.22v-3.76h1.22Z" />
				<path d="m674.23,893.53l-2.73,9.66h-1.33l-1.99-7.06c-.09-.3-.14-.63-.15-.98h-.03c-.03.33-.09.66-.18.97l-2,7.08h-1.31l-2.83-9.66h1.25l2.06,7.41c.09.31.14.63.16.97h.03c.02-.24.09-.56.21-.97l2.14-7.41h1.08l2.05,7.47c.07.26.13.56.16.9h.03c.02-.23.08-.54.18-.93l1.97-7.44h1.23Z" />
				<polygon points="679.87 893.53 675.23 904.8 674.2 904.8 678.83 893.53 679.87 893.53" />
				<path d="m681,903.2v-9.66h2.67c3.41,0,5.11,1.57,5.11,4.71,0,1.49-.47,2.69-1.42,3.6-.94.9-2.21,1.35-3.79,1.35h-2.56Zm1.13-8.64v7.61h1.44c1.27,0,2.25-.34,2.96-1.02.71-.68,1.06-1.64,1.06-2.88,0-2.48-1.32-3.71-3.95-3.71h-1.51Z" />
			</g>
		</g>
	)
}

export default PlanDD
